<template>
  <div class="pc_only">
    <h2 class="kojin-title"><slot>タイトル</slot></h2>
  </div>
  
  <span class="sp_only">
      <span class="sp-title" style="color:#FFF;background: #FF8400;" v-on:click="mypage()">
        ← <slot>タイトル</slot>
          <input type="text" class="form-control form-select" v-if="GlobalData.user_name && family_flg" v-bind:value="GlobalData.user_name" v-on:click="multipleusers_change" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.user_name" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
      </span>
    </span>
  <div class="p-2" style="margin-top:0;background-color:white">
    <!-- パンくずリスト -->
    <nav class="pc_only" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>
        <li class="breadcrumb-item" v-on:click="mypage" style="cursor:pointer">マイページ</li>
        <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
      </ol>
    </nav>
    
    <div id="manual_area" >

    <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />マイページのマニュアル</span>
    <span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

    </div>
      
    <br clear="all">

        <!-- ボタン -->
        <div class="pc_only"  style="text-align:center;padding:6px;width: 100%;">
            <button class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;margin-right:10px" v-on:click="mypage()">戻る</button>
        </div>

        
        <!--タイトル画像が存在する場合は表示-->
        <!--
        <img v-if="taiken.title_image" v-bind:src="taiken.title_image" style="max-width:100%;margin-bottom:10px">
-->
    <!-- タブ切り替え タブ2つ -->
    <div class="p-2">

      
        <div class="tabContents">
          
          <span style="text-align: left;float: left;padding:5px">
            {{ taiken.bunrui1 }}<br>
            <span v-if="shosai_disp[1] == 1">{{ taiken.bunrui2 }}</span>
          </span><br>
          <!-- 施設・地域活動 -->
                <table class="vy-form-table" v-if="taiken.shubetsu == 1" style="margin-bottom:10px">
                    <!-- No. プログラム名称 -->
                    <tr>
                        <th>
                            <label for=""  class="pc_only">No.：名称（施設名等） </label>
                        </th>
                        <td style="text-align: left;font-size:22px;color:#030ba0">
                            <b>{{ taiken.taiken_no_text }}：{{ taiken.name }}
                              <template v-if="moshikomi_count != 0">
                                （{{ (moshikomi_count+1) }}回目）
                              </template>
                            </b>
                        </td>
                    </tr>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <!-- 申込日時 -->
                    <tr>
                        <th>
                            <label for="">申込日時</label>
                        </th>
                        <td style="text-align: left;">
                            {{ EuDateTimeSetting(moushikomi_date) }}
                        </td>
                    </tr>
                     <template v-if="taiken.s_disp == 0 && (( taiken.s_name != null && taiken.s_name != '') ||
                            ( taiken.s_jusyo != null && taiken.s_jusyo != '') ||
                            ( taiken.s_tel != null && taiken.s_tel != '') ||
                            ( taiken.s_fax != null && taiken.s_fax != '') ||
                            ( taiken.s_email != null && taiken.s_email != '') ||
                            ( taiken.s_tantou != null && taiken.s_tantou != '') ||
                            ( taiken.s_bikou != null && taiken.s_bikou != ''))">
                            
                    <tr>
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                  <tr  >
                    <th >
                      <label for="">受入先情報</label>
                    </th>
                    <td >
                    <div style="text-align: left;" v-if="( taiken.s_name != null && taiken.s_name != '')">
                        <b>名称：</b>{{taiken.s_name}}
                    </div>

                    <div style="text-align: left;" v-if="( taiken.s_jusyo != null && taiken.s_jusyo != '')">
                      <b>住所：</b>{{taiken.s_jusyo}}
                      
                    </div>
                    <div style="text-align: left;" v-if="( taiken.s_tel != null && taiken.s_tel != '')">
                      <b>TEL：</b>{{taiken.s_tel}}
                    </div>
                    <div style="text-align: left;" v-if="( taiken.s_fax != null && taiken.s_fax != '')">
                      <b>FAX：</b>{{taiken.s_fax}}
                    </div>
                    <div style="text-align: left;" v-if="( taiken.s_email != null && taiken.s_email != '')">
                      <b>E-Mail：</b>{{taiken.s_email}}
                    </div>
                    <div style="text-align: left;" v-if="( taiken.s_tantou != null && taiken.s_tantou != '')">
                      <b>担当者：</b>{{taiken.s_tantou}}
                    </div>
                    <div style="text-align: left;" v-if="( taiken.s_bikou != null && taiken.s_bikou != '')">
                      <b>その他の情報：</b>{{taiken.s_bikou}}
                    </div>

                    </td>
                  </tr>
                </template>
                <!-- 受入先からのコメント -->
                    <template v-if="shosai_disp[6] == 1 && taiken.s_comment!=null">
                      <tr>
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      
                      <!-- 受入先からのコメント -->
                      
                      <tr>
                          <th>
                              <label for="">受入先からのコメント</label>
                          </th>
                          <td style="text-align: left;">
                              {{taiken.s_comment}}
                          </td>
                      </tr>
                    </template>
                    <tr v-if="disp_sub_jisseki.length == 0">
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <!-- 活動内容 -->
                    <template v-if="disp_jisseki.length != 0">
                       <template v-if="disp_sub_jisseki.length != 0">
                      
                        
                        <tr>
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th colspan="2" style="font-size:18px">
                                <label for="">【活動1】</label>
                            </th>
                        </tr>
                       </template>
                      <template v-if="shosai_disp[3] == 1">
                        <tr>
                            <th>
                                <label for="">活動内容</label>
                            </th>
                            <td style="text-align: left;">
                                {{ taiken.naiyou }}
                            </td>
                        </tr>
                      </template>
                      <!-- 開催地名 -->
                      <template v-if="shosai_disp[18] == 1 && taiken.k_name != null && taiken.k_name != ''">
                          <tr >
                              <td colspan="2"><div class="vy-dotted"></div></td>
                          </tr>
                          <tr>
                              <th>
                                  <label class="sp_only">
                                      開催地名
                                  </label>
                                  
                                  <span class="pc_only">
                                      <label >
                                          開催地名
                                      </label>
                                  </span>
                                  
                              </th>
                              <td style="text-align: left;" >
                                  {{ taiken.k_name }}
                              </td>
                          </tr>
                      </template>
                      <!-- 施設住所（開催場所） -->
                      <template v-if="shosai_disp[4] == 1">
                      <tr >
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      
                      <tr>
                          <th>
                            <label class="sp_only">
                                      施設住所（開催場所）
                                      <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('住所をタップすると、開催場所までの道案内を行います。<br>（Google Map等の地図アプリを利用します。）')" />
                                  </label>
                                  
                                  <span class="pc_only">
                                      <label >
                                          施設住所（開催場所）
                                      </label>
                                      <span class="balloon_parent ">
                                          <img class="q_icon" src="../../images/mark/qmark.png"  />
                                          <span class="balloon">
                                              住所をタップすると、開催場所までの道案内を行います。<br>
                                              （Google Map等の地図アプリを利用します。）
                                          </span>
                                      </span>
                                  </span>
                          </th>
                          <td style="text-align: left;color:red;cursor:pointer" v-on:click="jusho(taiken.k_jusyo)">
                              <u>{{ taiken.k_jusyo }}</u>
                          </td>
                      </tr>
                    </template>
                    <template v-if="shosai_disp[20] == 1 && taiken.k_access != null && taiken.k_access != ''">
                          <tr >
                              <td colspan="2"><div class="vy-dotted"></div></td>
                          </tr>
                          <tr>
                              <th>
                                  <label class="sp_only">
                                      アクセス方法
                                  </label>
                                  
                                  <span class="pc_only">
                                      <label >
                                          アクセス方法
                                      </label>
                                  </span>
                                  
                              </th>
                              <td>
                                {{ taiken.k_access }}
                              </td>
                          </tr>
                      </template>
                    <template v-if="shosai_disp[19] == 1 && taiken.k_tel != null && taiken.k_tel != ''">
                          <tr >
                              <td colspan="2"><div class="vy-dotted"></div></td>
                          </tr>
                          <tr>
                              <th>
                                  <label class="sp_only">
                                      連絡先
                                  </label>
                                  
                                  <span class="pc_only">
                                      <label >
                                          連絡先
                                      </label>
                                  </span>
                                  
                              </th>
                              <td style="text-align: left;color:red;cursor:pointer" >
                                  <u>{{ taiken.k_tel }}</u>
                              </td>
                          </tr>
                      </template>
                      <!-- 参加にあたって -->
                      
                      <tr>
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      <tr>
                            <th>
                                <label for="">参加にあたって</label>
                            </th>
                            <td style="text-align: left;">
                              <template v-if="shosai_disp[9] == 1">
                                <b>参加費：</b>
                                  <span v-if="taiken.sankahi == null || taiken.sankahi == ''">
                                      不要
                                  </span>
                                  <span v-else>
                                  {{taiken.sankahi}}
                                  </span>
                              </template>
                              <template v-if="shosai_disp[10] == 1">
                                  <br>
                                <b>検温等：</b>
                                    <span v-if="taiken.kensa == null || taiken.kensa == ''">
                                        不要
                                    </span>
                                    <span v-else>
                                    {{taiken.kensa}}
                                    </span>
                              </template>
                              <template v-if="shosai_disp[17] == 1">
                                  <br>
                                <b>検便：</b>
                                 <span v-if="taiken.kenben == null || taiken.kenben == ''">
                                    不要
                                </span>
                                <span v-else>
                                {{taiken.kenben}}
                                </span>
                              </template>
                              <template v-if="shosai_disp[11] == 1">
                                <br>
                                <b>マスク着用：</b>
                                <span v-if="taiken.mask == null || taiken.mask == ''">
                                    不要
                                </span>
                                <span v-else>
                                {{taiken.mask}}
                                </span>
                              </template>
                              <template v-if="shosai_disp[12] == 1">
                                <br>
                                <b>昼食：</b>
                                <span v-if="taiken.chusyoku == null || taiken.chusyoku == '' || taiken.chusyoku == '不要'">
                                    無し
                                </span>
                                <span v-else-if="taiken.chusyoku == '要'">
                                    有り
                                </span>
                                <span v-else>
                                {{taiken.chusyoku}}
                                </span>
                              </template>
                              <template v-if="shosai_disp[13] == 1 && (taiken.mochimono != null && taiken.mochimono != '')">
                                <br>
                                <b>持ち物：</b>
                                {{taiken.mochimono}}
                              </template>
                              <template v-if="shosai_disp[21] == 1 && (taiken.fukusou != null && taiken.fukusou != '')">
                                <br>
                                <b>服装：</b>
                                {{taiken.fukusou}}
                              </template>
                            </td>
                        </tr>
                    
                    
                    <template v-if="shosai_disp[7] == 1 && (taiken.shiryo_url!=null && taiken.shiryo_url!='')">
                      <tr >
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      
                      <!-- 添付資料 -->
                      <tr >
                          <th rowspan=2>
                              <label for="">添付資料</label>
                          </th>
                          <td style="text-align: left;">
                              {{taiken.shiryo_setsumei}}
                          </td>
                      </tr>
                      <!-- 添付資料 -->
                      <tr v-if="taiken.shiryo_url!=null && taiken.shiryo_url!=''">
                          <td style="text-align: left;">
                            <u class="pc_only" style="color:red;cursor:pointer" v-on:click="shiryo_open(taiken.shiryo_url)">資料を閲覧する</u>
                            <a v-bind:href="taiken.shiryo_url" class="sp_only" style="color:red;cursor:pointer" target="_blank">資料を閲覧する</a>
                          </td>
                      </tr>
                    </template>

                      <!-- その他（特記事項） -->
                    <template v-if="shosai_disp[8] == 1 && taiken.bikou!=null">
                    
                      <tr v-if="taiken.bikou!=null">
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      <tr v-if="taiken.bikou!=null">
                          <th>
                              <label for="">その他（特記事項）</label>
                          </th>
                          <td style="text-align: left;color:red">
                              {{taiken.bikou}}
                          </td>
                      </tr>
                    </template>
                    
                   
                     
                      <tr >
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      <tr>
                          <th colspan="2">
                              <label for="">プログラム申込日程</label>
                          </th>
                      </tr>

                      <tr>
                          <td colspan="2">
                            <!-- PC -->
                            <div  class="pc_only"  style="max-width: 700px">
                              <div class="vy-search-result-row-head ">
                                <div class="vy-search-result-column-kojin-name jyokyo_nittei"  style="width:25%">参加日</div>
                                <div class="vy-search-result-column-kojin-name jyokyo_nittei"  style="width:20%">時間</div>
                                <div class="vy-search-result-column-kojin-name jyokyo_nittei"  style="width:55%">状況</div>
                                            
                              </div>
                              <div v-for="(result,i) in disp_jisseki" v-bind:key="i" class="vy-search-result-row">
                                <div class="vy-search-result-row-head " >
                                <div class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:25%">
                                  <span v-if="result.kaisai_date != 'None' && result.kaisai_date != null">
                                    {{ DateSetting(result.kaisai_date) }}
                                  </span>
                                  <span v-else>
                                    ー
                                  </span>
                                </div>
                                <div class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:20%">
                                
                                    <span v-if="result.jikantai_start != 'None' && result.jikantai_start != null" style="margin-left:5px">{{ TimeSetting(result.jikantai_start) }}</span>
                                    <span v-if="result.jikantai_end != 'None' && result.jikantai_end != null">～{{ TimeSetting(result.jikantai_end) }}</span>
                                </div>
                                
                                <div v-if="result.jokyo == 0" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:55%;background-color:#f9a9a0">
                                  キャンセル待ち {{ result.cancel_count }}
                                </div>
                                <div v-else-if="result.jokyo == 1" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:55%;background-color:#FFE4E1;">
                                  未参加
                                </div>
                                <div v-else-if="result.jokyo == 2" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:55%;background-color:#ADE0EE;">
                                  <template v-if="result.checkin_date">
                                  {{ EuDateTimeSetting(result.checkin_date) }} 
                                  </template>
                                </div>
                                <div v-else-if="result.jokyo == 3 || result.jokyo == 4" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:55%;background-color:#ADE0EE;">
                                  欠席
                                </div>
                              </div>
                              </div>
                            </div>

                            <!-- スマホ -->
                            
                            <div  class="sp_only" >
                              <div v-for="(result,i) in disp_jisseki" v-bind:key="i" class="vy-search-result-row">
                                  <div class="vy-search-result-column-kojin-name jyokyo_nittei" style="width: 100%">
                                    <b>
                                    {{ DateSetting(result.kaisai_date) }}
                                    <span v-if="result.jikantai_start != 'None'" style="margin-left:5px">{{ TimeSetting(result.jikantai_start) }}</span>
                                    <span v-if="result.jikantai_end != 'None'">～{{ TimeSetting(result.jikantai_end) }}</span>
                                    </b>
                                  </div>
                                  <div v-if="result.jokyo == 0" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:100%;margin-bottom:10px;background-color:#f9a9a0;">
                                      
                                        キャンセル待ち {{ result.cancel_count }}
                                  </div>
                                  <div v-else-if="result.jokyo == 1" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:100%;margin-bottom:10px;background-color:#FFE4E1;">
                                      
                                        未参加
                                  </div>
                                  <div v-else-if="result.jokyo == 2" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:100%;margin-bottom:10px;background-color:#ADE0EE;">

                                  <template v-if="result.checkin_date">
                                  {{ EuDateTimeSetting(result.checkin_date) }} 
                                  </template>
                                  </div>
                                  <div v-else-if="result.jokyo == 3 || result.jokyo == 4" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:100%;margin-bottom:10px;background-color:#ADE0EE;">
                                    欠席
                                  </div>
                                
                                </div>
                            </div>
                        </td>
                    </tr>
                  </template>
                    <template v-if="disp_sub_jisseki.length != 0">
                      
                  <!-- 活動2以降 -->
                      
                    <template v-for="(taiken,s) in disp_sub_jisseki" v-bind:key="s">
                      <template v-if="disp_sub_jisseki[s].length">
                        
                        <tr>
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th colspan="2" style="font-size:18px">
                                <label for="">【活動{{s+2}}】</label>
                            </th>
                        </tr>
                      <template v-if="shosai_disp[3] == 1">
                     
                        <tr>
                            <th>
                                <label for="">活動内容</label>
                            </th>
                            <td style="text-align: left;">
                                {{ taiken[0].katsudou.naiyou }}
                            </td>
                        </tr>
                      </template>
                      <!-- 開催地名 -->
                      <template v-if="shosai_disp[18] == 1 && (taiken[0].katsudou.k_name != null && taiken[0].katsudou.k_name != '')">
                          <tr >
                              <td colspan="2"><div class="vy-dotted"></div></td>
                          </tr>
                          <tr>
                              <th>
                                  <label class="sp_only">
                                      開催地名
                                  </label>
                                  
                                  <span class="pc_only">
                                      <label >
                                          開催地名
                                      </label>
                                  </span>
                                  
                              </th>
                              <td style="text-align: left;" >
                                  {{ taiken[0].katsudou.k_name }}
                              </td>
                          </tr>
                      </template>
                      <!-- 施設住所（開催場所） -->
                      <template v-if="shosai_disp[4] == 1">
                      <tr >
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      
                      <tr>
                          <th>
                            <label class="sp_only">
                                      施設住所（開催場所）
                                      <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('住所をタップすると、開催場所までの道案内を行います。<br>（Google Map等の地図アプリを利用します。）')" />
                                  </label>
                                  
                                  <span class="pc_only">
                                      <label >
                                          施設住所（開催場所）
                                      </label>
                                      <span class="balloon_parent ">
                                          <img class="q_icon" src="../../images/mark/qmark.png"  />
                                          <span class="balloon">
                                              住所をタップすると、開催場所までの道案内を行います。<br>
                                              （Google Map等の地図アプリを利用します。）
                                          </span>
                                      </span>
                                  </span>
                          </th>
                          <td style="text-align: left;color:red;cursor:pointer" v-on:click="jusho(taiken[0].katsudou.k_jusyo)">
                              <u>{{ taiken[0].katsudou.k_jusyo }}</u>
                          </td>
                      </tr>
                    </template>
                    <template v-if="shosai_disp[20] == 1 && taiken[0].katsudou.k_access != null && taiken[0].katsudou.k_access != ''">
                          <tr >
                              <td colspan="2"><div class="vy-dotted"></div></td>
                          </tr>
                          <tr>
                              <th>
                                  <label class="sp_only">
                                      アクセス方法
                                  </label>
                                  
                                  <span class="pc_only">
                                      <label >
                                          アクセス方法
                                      </label>
                                  </span>
                                  
                              </th>
                              <td >
                                <u>{{ taiken[0].katsudou.k_access }}</u>                                  
                              </td>
                          </tr>
                      </template>
                    <template v-if="shosai_disp[19] == 1 && taiken[0].katsudou.k_tel != null && taiken[0].katsudou.k_tel != ''">
                          <tr >
                              <td colspan="2"><div class="vy-dotted"></div></td>
                          </tr>
                          <tr>
                              <th>
                                  <label class="sp_only">
                                      連絡先
                                  </label>
                                  
                                  <span class="pc_only">
                                      <label >
                                          連絡先
                                      </label>
                                  </span>
                                  
                              </th>
                              <td style="text-align: left;color:red;cursor:pointer" >
                                  <u>{{ taiken[0].katsudou.k_tel }}</u>
                              </td>
                          </tr>
                      </template>
                      
                      <tr>
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      <tr>
                            <th>
                                <label for="">参加にあたって</label>
                            </th>
                            <td style="text-align: left;">
                              <template v-if="shosai_disp[9] == 1">
                                <b>参加費：</b>
                                  <span v-if="taiken[0].katsudou.sankahi == null || taiken[0].katsudou.sankahi == ''">
                                      不要
                                  </span>
                                  <span v-else>
                                  {{taiken[0].katsudou.sankahi}}
                                  </span>
                              </template>
                              <template v-if="shosai_disp[10] == 1">
                                  <br>
                                <b>検温等：</b>
                                    <span v-if="taiken[0].katsudou.kensa == null || taiken[0].katsudou.kensa == ''">
                                        不要
                                    </span>
                                    <span v-else>
                                    {{taiken[0].katsudou.kensa}}
                                    </span>
                              </template>
                              <template v-if="shosai_disp[17] == 1">
                                  <br>
                                <b>検便：</b>
                                 <span v-if="taiken[0].katsudou.kenben == null || taiken[0].katsudou.kenben == ''">
                                    不要
                                </span>
                                <span v-else>
                                {{taiken[0].katsudou.kenben}}
                                </span>
                              </template>
                              <template v-if="shosai_disp[11] == 1">
                                <br>
                                <b>マスク着用：</b>
                                <span v-if="taiken[0].katsudou.mask == null || taiken[0].katsudou.mask == ''">
                                    不要
                                </span>
                                <span v-else>
                                {{taiken[0].katsudou.mask}}
                                </span>
                              </template>
                              <template v-if="shosai_disp[12] == 1">
                                <br>
                                <b>昼食：</b>
                                <span v-if="taiken[0].katsudou.chusyoku == null || taiken[0].katsudou.chusyoku == '' || taiken[0].katsudou.chusyoku == '不要'">
                                    無し
                                </span>
                                <span v-else-if="taiken[0].chusyoku == '要'">
                                    有り
                                </span>
                                <span v-else>
                                {{taiken[0].katsudou.chusyoku}}
                                </span>
                              </template>
                              <template v-if="shosai_disp[13] == 1 && (taiken[0].katsudou.mochimono != null && taiken[0].katsudou.mochimono != '')">
                                <br>
                                <b>持ち物：</b>
                                {{taiken[0].katsudou.mochimono}}
                              </template>
                              
                              <template v-if="shosai_disp[21] == 1 && (taiken[0].katsudou.fukusou != null && taiken[0].katsudou.fukusou != '')">
                                <br>
                                <b>服装：</b>
                                {{taiken[0].katsudou.fukusou}}
                              </template>
                            </td>
                        </tr>
                    <!-- 受入先からのコメント -->
                    <template v-if="shosai_disp[6] == 1 && taiken[0].katsudou.s_comment!=null">
                      <tr>
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      
                      <!-- 受入先からのコメント -->
                      
                      <tr>
                          <th>
                              <label for="">受入先からのコメント</label>
                          </th>
                          <td style="text-align: left;">
                              {{taiken[0].katsudou.s_comment}}
                          </td>
                      </tr>
                    </template>
                    
                    <template v-if="shosai_disp[7] == 1 && (taiken[0].katsudou.shiryo_url!=null && taiken[0].katsudou.shiryo_url!='')">
                      <tr >
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      
                      <!-- 添付資料 -->
                      <tr >
                          <th rowspan=2>
                              <label for="">添付資料</label>
                          </th>
                          <td style="text-align: left;">
                              {{taiken[0].katsudou.shiryo_setsumei}}
                          </td>
                      </tr>
                      <!-- 添付資料 -->
                      <tr v-if="taiken[0].katsudou.shiryo_url!=null && taiken[0].katsudou.shiryo_url!=''">
                          <td style="text-align: left;">
                            <u class="pc_only" style="color:red;cursor:pointer" v-on:click="shiryo_open(taiken[0].katsudou.shiryo_url)">資料を閲覧する</u>
                            <a v-bind:href="taiken[0].katsudou.shiryo_url" class="sp_only" style="color:red;cursor:pointer" target="_blank">資料を閲覧する</a>
                          </td>
                      </tr>
                    </template>

                      <!-- その他（特記事項） -->
                    <template v-if="shosai_disp[8] == 1 && taiken[0].katsudou.bikou!=null">
                    
                      <tr v-if="taiken[0].katsudou.bikou!=null">
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      <tr v-if="taiken[0].katsudou.bikou!=null">
                          <th>
                              <label for="">その他（特記事項）</label>
                          </th>
                          <td style="text-align: left;color:red">
                              {{taiken[0].katsudou.bikou}}
                          </td>
                      </tr>
                    </template>
                    
                    
                     
                      <tr >
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      <tr>
                          <th colspan="2">
                              <label for="">プログラム申込日程</label>
                          </th>
                      </tr>

                      <tr>
                          <td colspan="2">
                            <!-- PC -->
                            <div  class="pc_only"  style="max-width: 700px">
                              <div class="vy-search-result-row-head ">
                                <div class="vy-search-result-column-kojin-name jyokyo_nittei"  style="width:25%">参加日</div>
                                <div class="vy-search-result-column-kojin-name jyokyo_nittei"  style="width:20%">時間</div>
                                <div class="vy-search-result-column-kojin-name jyokyo_nittei"  style="width:55%">状況</div>
                                            
                              </div>
                              <div v-for="(result,i) in disp_sub_jisseki[s]" v-bind:key="i" class="vy-search-result-row">
                                <div class="vy-search-result-row-head " >
                                <div class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:25%">
                                  <span v-if="result.kaisai_date != 'None' && result.kaisai_date != null">
                                    {{ DateSetting(result.kaisai_date) }}
                                  </span>
                                  <span v-else>
                                    ー
                                  </span>
                                </div>
                                <div class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:20%">
                                
                                    <span v-if="result.jikantai_start != 'None' && result.jikantai_start != null" style="margin-left:5px">{{ TimeSetting(result.jikantai_start) }}</span>
                                    <span v-if="result.jikantai_end != 'None' && result.jikantai_end != null">～{{ TimeSetting(result.jikantai_end) }}</span>
                                </div>
                                
                                <div v-if="result.jokyo == 0" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:55%;background-color:#f9a9a0">
                                  キャンセル待ち {{ result.cancel_count }}
                                </div>
                                <div v-else-if="result.jokyo == 1" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:55%;background-color:#FFE4E1;">
                                  未参加
                                </div>
                                <div v-else-if="result.jokyo == 2" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:55%;background-color:#ADE0EE;">
                                  <template v-if="result.checkin_date">
                                  {{ EuDateTimeSetting(result.checkin_date) }} 
                                  </template>
                                </div>
                                <div v-else-if="result.jokyo == 3 || result.jokyo == 4" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:55%;background-color:#ADE0EE;">
                                  欠席
                                </div>
                              </div>
                              </div>
                            </div>

                            <!-- スマホ -->
                            
                            <div  class="sp_only" >
                              <div v-for="(result,i) in disp_sub_jisseki[s]" v-bind:key="i" class="vy-search-result-row">
                                  <div class="vy-search-result-column-kojin-name jyokyo_nittei" style="width: 100%">
                                    <b>
                                    {{ DateSetting(result.kaisai_date) }}
                                    <span v-if="result.jikantai_start != 'None'" style="margin-left:5px">{{ TimeSetting(result.jikantai_start) }}</span>
                                    <span v-if="result.jikantai_end != 'None'">～{{ TimeSetting(result.jikantai_end) }}</span>
                                    </b>
                                  </div>
                                  <div v-if="result.jokyo == 0" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:100%;margin-bottom:10px;background-color:#f9a9a0">
                                      
                                        キャンセル待ち {{ result.cancel_count }}
                                  </div>
                                  <div v-else-if="result.jokyo == 1" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:100%;margin-bottom:10px;background-color:#FFE4E1;">
                                      
                                        未参加
                                  </div>
                                  <div v-else-if="result.jokyo == 2" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:100%;margin-bottom:10px;background-color:#ADE0EE;">

                                  <template v-if="result.checkin_date">
                                  {{ EuDateTimeSetting(result.checkin_date) }} 
                                  </template>
                                  </div>
                                  <div v-else-if="result.jokyo == 3 || result.jokyo == 4" class="vy-search-result-column-kojin-name jyokyo_nittei" style="width:100%;margin-bottom:10px;background-color:#ADE0EE;">
                                    欠席
                                  </div>
                                
                                </div>
                            </div>
                        </td>
                    </tr>
                    </template>
                    </template>
                    </template>
                    
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    
                    <template v-if="disp_jizen_list.length!=0 && Shakyo_data.jizen_jisshi == 1">
                    <tr>
                        <th colspan="2">
                            <label for="">事前説明会</label>
                        </th>
                    </tr>
                    <tr >
                        <td colspan="2">
                          <div align="left" v-for="(jizen_column,i) in disp_jizen_list" v-bind:key="i" class="jizen_disp">
                            <!-- 種類が対面・オンライン・特殊の場合 -->
                            <table v-if="jizen_column.syurui != '3'" border="1" rules="all" style="width:100%;max-width:700px;border-collapse:collapse;margin-bottom:12px;border:2px solid #06F;background-color:cornsilk">
                            <tr>
                              <td width="100px"><b>説明会名称</b></td>
                              <td ><b>{{ jizen_column.jizen_name }}</b></td>
                            </tr>
                              <tr>
                              <td><b>種類</b></td>
                              <td ><b>{{ syurui_list[jizen_column.syurui] }}</b></td>
                            </tr>
                            <tr>
                              <td ><b>開催日</b></td>
                              <td >
                               
                                    <template v-if="jizen_column.kensyu_date">
                                      {{ DateSetting(jizen_column.kensyu_date) }}
                                      
                                    </template>
                                    <template v-else>
                                      ー
                                    </template> 
                                
                              </td>
                            </tr>
                            <tr>
                              <td ><b>説明会場所</b></td>
                              <td >{{ jizen_column.basyo }}</td>
                            </tr>
                            
                            <template v-if="jizen_column.syurui == '1' || jizen_column.syurui == '3'">
                              <tr>
                                <td ><b>住所</b></td>
                                <td >
                                  <span v-if="jizen_column.jusyo == '' || jizen_column.jusyo == null  || jizen_column.jusyo == 'None'">ー</span>
                                  <u v-else style="color:red;cursor:pointer" v-on:click="googlemap(jizen_column.jusyo)">{{ jizen_column.jusyo }}</u>
                                </td>
                              </tr>
                            </template>
                            <tr>
                              <td ><b>時間</b></td>
                              <td >
                                {{ TimeSetting(jizen_column.jizen_jikantai_start) }}&nbsp;～&nbsp;{{ TimeSetting(jizen_column.jizen_jikantai_end) }}
                              </td>
                            </tr>

                            <template v-if="jizen_column.bikou1 != '' && jizen_column.bikou1 != null && jizen_column.bikou1 != 'None'">
                                <tr>
                                  <td><b>特記事項</b></td>
                                  <td>
                                      <span style="color:red;">{{ jizen_column.bikou1 }}</span>
                                  </td>
                              </tr>

                            </template>
                            <tr style="border-top:2px solid #06F">
                              <td style="background-color:orange"><b>参加状況</b></td>
                              <td v-if="jizen_column.jokyo == 2" style="background-color:#ADE0EE;">
                                【参加済】<br class="sp_only">{{ EuDateTimeSetting(jizen_column.checkin_date) }} 
                              </td>
                              <td v-else style="background-color:#FFE4E1;" >
                                <span v-if="jizen_column.syurui == 2">
                                  <u  style="color:red;cursor:pointer" v-on:click="online_sanka(jizen_column.url)">オンライン説明会に参加する</u>
                                </span>
                                <span v-else>未参加</span>
                              </td>
                            </tr>
                            </table>

                            <!-- 種類が動画視聴の場合 -->
                            <table v-else border="1" rules="all" style="width:100%;max-width:700px;border-collapse:collapse;margin-bottom:12px;border:2px solid #06F;background-color:cornsilk">
                            <tr>
                              <td width="100px"><b>説明会名称</b></td>
                              <td ><b>{{ jizen_column.jizen_name }}</b></td>
                            </tr>
                              <tr>
                              <td><b>種類</b></td>
                              <td ><b>動画視聴</b></td>
                            </tr>
                             <tr>
                              <td ><b>視聴期間</b></td>
                              <td >

                                  <template v-if="jizen_column.movie_start_date && jizen_column.kensyu_date">
                                    <!--両方とも入力-->
                                    {{ DateSetting(jizen_column.movie_start_date) }} ～ {{ DateSetting(jizen_column.kensyu_date) }}
                                  </template>
                                  <template v-else-if="!jizen_column.movie_start_date && jizen_column.kensyu_date">
                                    <!--至のみ入力-->
                                    {{ DateSetting(jizen_column.kensyu_date) }} まで
                                  </template>
                                  <template v-else-if="jizen_column.movie_start_date && !jizen_column.kensyu_date">
                                    <!--自のみ入力-->
                                    {{ DateSetting(jizen_column.movie_start_date) }} 以降
                                  </template>
                                    <template v-else>
                                      ー
                                    </template> 

                              </td>
                            </tr>
                            <template v-if="jizen_column.bikou1 != '' && jizen_column.bikou1 != null && jizen_column.bikou1 != 'None'">
                                <tr>
                                  <td><b>特記事項</b></td>
                                  <td>
                                      <span style="color:red;">{{ jizen_column.bikou1 }}</span>
                                  </td>
                              </tr>

                            </template>
                            <tr style="border-top:2px solid #06F">
                              <td style="background-color:orange"><b>状況</b></td>
                              <td v-if="jizen_column.jokyo == 2" style="background-color:#ADE0EE;">
                                【視聴済】<br class="sp_only">{{ EuDateTimeSetting(jizen_column.checkin_date) }} <br>
                                <template v-if="Shichou_kikan(jizen_column.kensyu_date,jizen_column.movie_start_date)">
                                  <u style="color:red;cursor:pointer" v-on:click="movie_shichou(jizen_column.url,jizen_column.jizen_id,2)">動画を視聴する</u>
                                </template>
                                  <template v-else>
                                    <b>動画の視聴期間外です。</b>
                                  </template>
                              </td>
                              <td v-else style="background-color:#FFE4E1;" >
                                  <template v-if="Shichou_kikan(jizen_column.kensyu_date,jizen_column.movie_start_date)">
                                    <u style="color:red;cursor:pointer" v-on:click="movie_shichou(jizen_column.url,jizen_column.jizen_id,1)">動画を視聴する</u>
                                  </template>
                                  <template v-else>
                                    <b>動画の視聴期間外です。</b>
                                  </template>
                              </td>
                            </tr>
                            </table>
                            </div>
                        </td>
                    </tr>
                    </template>
                    
                    <template v-if="disp_jigo_list.length!=0 && Shakyo_data.jigo_jisshi == 1">
                    <tr >
                        <th colspan="2">
                            <label for="">事後集会</label>
                        </th>
                    </tr>
                    <tr >
                        <td colspan="2">
                          <div align="left" v-for="(jigo_column,i) in disp_jigo_list" v-bind:key="i" class="jizen_disp">

                            <table border="1" rules="all" style="width:100%;max-width:700px;border-collapse:collapse;margin-bottom:12px;border:2px solid #06F;background-color:cornsilk">
                            <tr>
                              <td width="150px"><b>集会名称</b></td>
                              <td ><b>{{ jigo_column.jigo_name }}</b></td>
                            </tr>
                              <tr>
                              <td><b>種類</b></td>
                              <td ><b>{{ syurui_list[jigo_column.jigo_syurui] }}</b></td>
                            </tr>
                            <tr>
                              <td ><b>開催日</b></td>
                              <td >{{ DateSetting(jigo_column.jigo_kaisai) }}</td>
                            </tr>
                            <tr>
                              <td ><b>開催場所</b></td>
                              <td >{{ jigo_column.jigo_basyo }}</td>
                            </tr>
                            <template v-if="jigo_column.jigo_syurui == 1">
                              <tr>
                                <td ><b>住所</b></td>
                                <td >
                                  <span v-if="jigo_column.jigo_jusyo == '' || jigo_column.jigo_jusyo == null  || jigo_column.jigo_jusyo == 'None'">ー</span>
                                  <u v-else style="color:red;cursor:pointer" v-on:click="jusho(jigo_column.jigo_jusyo)">{{ jigo_column.jigo_jusyo }}</u>
                                </td>
                              </tr>
                            </template>
                            <tr>
                              <td ><b>時間</b></td>
                              <td >
                                {{ TimeSetting(jigo_column.jigo_jikantai_start) }}&nbsp;～&nbsp;{{ TimeSetting(jigo_column.jigo_jikantai_end) }}
                              </td>
                            </tr>
                            <template  v-if="jigo_column.jigo_bikou1 != '' && jigo_column.jigo_bikou1 != null && jigo_column.jigo_bikou1 != 'None'">
                                <tr>
                                  <td><b>特記事項</b></td>
                                  <td>
                                      <span style="color:red;">{{ jigo_column.jigo_bikou1 }}</span>
                                  </td>
                              </tr>
                            </template>
                            <tr style="border-top:2px solid #06F">
                              <td style="background-color:orange"><b>参加状況</b></td>
                              <td v-if="jigo_column.jokyo == 2" style="background-color:#ADE0EE;">
                                【参加済】<br class="sp_only">{{ EuDateTimeSetting(jigo_column.checkin_date) }} 
                              </td>
                              <td v-else style="background-color:#FFE4E1;" >
                                <span v-if="jigo_column.jigo_syurui == 2">
                                  <u  style="color:red;cursor:pointer" v-on:click="online_sanka(jigo_column.jigo_url)">オンライン集会に参加する</u>
                                </span>
                                <span v-else>未参加</span>
                              </td>
                            </tr>
                            
                            <tr  v-if="jigo_column.jigo_syurui == 2">
                              <td style="background-color:orange"><b>ミーティングID</b></td>
                              <td >
                                <span v-if="jigo_column.jigo_meeting_id == '' || jigo_column.jigo_meeting_id == null  || jigo_column.jigo_meeting_id == 'None'">ー</span>
                                <span v-else>{{jigo_column.jigo_meeting_id}}</span>
                                
                              </td>
                              
                            </tr>
                            <tr   v-if="jigo_column.jigo_syurui == 2">
                              <td style="background-color:orange"><b>パスコード</b></td>
                              <td >
                                <span v-if="jigo_column.jigo_passcode == '' || jigo_column.jigo_passcode == null  || jigo_column.jigo_passcode == 'None'">ー</span>
                                <span v-else>{{jigo_column.jigo_passcode}}</span>
                              </td>
                              
                            </tr>
                            </table>

                            </div>
                        </td>
                    </tr>
                    </template>
                </table>

                <!-- 制作・寄付活動 -->
                <table class="vy-form-table" v-if="taiken.shubetsu == 2" style="margin-bottom:10px">

                    <!-- No. プログラム名称 -->
                    <tr>
                        <th>
                            <label for=""  class="pc_only">No.：名称（施設名等） </label>
                        </th>
                        <td style="text-align: left;font-size:22px;color:#030ba0">
                            <b>{{ taiken.taiken_no_text }}：{{ taiken.name }}
                              <template v-if="moshikomi_count != 0">
                                （{{ (moshikomi_count+1) }}回目）
                              </template>
                            </b>
                        </td>
                    </tr>

                    <!-- 活動内容 -->
                     
                  <template v-if="shosai_disp[3] == 1">
                    <tr>
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <tr>
                        <th>
                            <label for="">活動内容</label>
                        </th>
                        <td style="text-align: left;">
                            {{ taiken.naiyou }}
                        </td>
                    </tr>
                  </template>
                  
                    <!-- 施設住所 -->
                  <template v-if="shosai_disp[4] == 1">
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <tr>
                        <th>
                          <label class="sp_only">
                                    施設住所
                                    <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('住所をタップすると、提出場所までの道案内を行います。<br>（Google Map等の地図アプリを利用します。）')" />
                                </label>
                                
                                <span class="pc_only">
                                    <label for="">施設住所</label>
                                    <span class="balloon_parent">
                                        <img class="q_icon" src="../../images/mark/qmark.png"  />
                                        <span class="balloon">
                                            住所をタップすると、提出場所までの道案内を行います。<br>
                                            （Google Map等の地図アプリを利用します。）
                                        </span>
                                    </span>
                                </span> 
                        </th>
                        <td style="text-align: left;color:red;cursor:pointer" v-on:click="jusho(taiken.k_jusyo)">
                            <u>{{ taiken.k_jusyo }}</u>
                        </td>
                    </tr>
                  </template>
                  <template v-if="shosai_disp[19] == 1 && taiken.k_tel != null && taiken.k_tel != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    連絡先
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        連絡先
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;color:red;cursor:pointer" >
                                <u>{{ taiken.k_tel }}</u>
                            </td>
                        </tr>
                    </template>
                    <!-- 開催期間 -->
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <tr>
                        <th>
                            <label for="">開催期間</label>
                        </th>
                        <td style="text-align: left">
                            
                            {{DateSetting(taiken.kaisai_start)}}
                            <span v-if="taiken.kaisai_end && taiken.kaisai_end != taiken.kaisai_start"> ～ {{DateSetting(taiken.kaisai_end)}}</span>
                        </td>
                    </tr>
                    
                    <!-- 制作・寄付活動条件 -->
                  <template v-if="shosai_disp[14] == 1 && taiken.seisaku_joken!=null">
                    <tr>
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>

                    <tr>
                        <th>
                            <label for="seisaku_joken">制作・寄付活動条件</label>
                        </th>
                        <td style="text-align: left;">
                            {{taiken.seisaku_joken}}
                        </td>
                    </tr>
                  </template>
                  
                    <!-- 届け先 -->
                  <template v-if="shosai_disp[15] == 1 ">
                  
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <tr>
                        <th>
                            <label for="todokesaki">届け先</label>
                        </th>
                        <td style="text-align: left;">
                            {{taiken.todokesaki}}
                        </td>
                    </tr>
                  </template>
                  
                  <template v-if="shosai_disp[6] == 1 && taiken.s_comment!=null">
                    <tr>
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <!-- 受入先からのコメント -->
                    <tr>
                        <th>
                            <label for="">受入先からのコメント</label>
                        </th>
                        <td style="text-align: left;">
                            {{taiken.s_comment}}
                        </td>
                    </tr>
                  </template>
                  
                    <!-- 添付資料 -->
                  <template v-if="shosai_disp[7] == 1 && (taiken.shiryo_url!=null && taiken.shiryo_url!='')">
                    <tr>
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <tr>
                        <th rowspan=2>
                            <label for="">添付資料</label>
                        </th>
                        <td style="text-align: left;">
                            {{taiken.shiryo_setsumei}}
                        </td>
                    </tr>

                    <tr v-if="taiken.shiryo_url!=null">
                        <td style="text-align: left;">
                          <u class="pc_only" style="color:red;cursor:pointer" v-on:click="shiryo_open(taiken.shiryo_url)">資料を閲覧する</u>
                          <a v-bind:href="taiken.shiryo_url" class="sp_only" style="color:red;cursor:pointer" target="_blank">資料を閲覧する</a>
                        </td>
                    </tr>
                    
                  </template>
                  <template v-if="shosai_disp[8] == 1 && taiken.bikou!=null">
                  
                    <tr>
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <!-- その他（特記事項） -->
                    <tr >
                        <th>
                            <label for="">その他（特記事項）</label>
                        </th>
                        <td style="text-align: left;">
                            {{taiken.bikou}}
                        </td>
                    </tr>
                  </template>
                  
                 
                    <!-- 申込日時 -->
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <tr>
                        <th>
                            <label for="">申込日時</label>
                        </th>
                        <td style="text-align: left;">
                            {{ EuDateTimeSetting(moushikomi_date) }}
                        </td>
                    </tr>
                    <template v-if="taiken.s_disp == 0">
                      <template v-if=" ( taiken.s_name != null && taiken.s_name != '') ||
                                ( taiken.s_jusyo != null && taiken.s_jusyo != '') ||
                                ( taiken.s_tel != null && taiken.s_tel != '') ||
                                ( taiken.s_fax != null && taiken.s_fax != '') ||
                                ( taiken.s_email != null && taiken.s_email != '') ||
                                ( taiken.s_tantou != null && taiken.s_tantou != '') ||
                                ( taiken.s_bikou != null && taiken.s_bikou != '')">
                                
                        <tr>
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                      <tr  >
                        <th >
                          <label for="">受入先情報</label>
                        </th>
                        <td >
                        <div style="text-align: left;" v-if="( taiken.s_name != null && taiken.s_name != '')">
                            <b>名称：</b>{{taiken.s_name}}
                        </div>

                        <div style="text-align: left;" v-if="( taiken.s_jusyo != null && taiken.s_jusyo != '')">
                          <b>住所：</b>{{taiken.s_jusyo}}
                          
                        </div>
                        <div style="text-align: left;" v-if="( taiken.s_tel != null && taiken.s_tel != '')">
                          <b>TEL：</b>{{taiken.s_tel}}
                        </div>
                        <div style="text-align: left;" v-if="( taiken.s_fax != null && taiken.s_fax != '')">
                          <b>FAX：</b>{{taiken.s_fax}}
                        </div>
                        <div style="text-align: left;" v-if="( taiken.s_email != null && taiken.s_email != '')">
                          <b>E-Mail：</b>{{taiken.s_email}}
                        </div>
                        <div style="text-align: left;" v-if="( taiken.s_tantou != null && taiken.s_tantou != '')">
                          <b>担当者：</b>{{taiken.s_tantou}}
                        </div>
                        <div style="text-align: left;" v-if="( taiken.s_bikou != null && taiken.s_bikou != '')">
                          <b>その他の情報：</b>{{taiken.s_bikou}}
                        </div>

                        </td>
                      </tr>
                    </template>
                  </template>
                  <!-- 受入先からのコメント -->
                    <template v-if="shosai_disp[6] == 1 && taiken.s_comment!=null">
                      <tr>
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      
                      <!-- 受入先からのコメント -->
                      
                      <tr>
                          <th>
                              <label for="">受入先からのコメント</label>
                          </th>
                          <td style="text-align: left;">
                              {{taiken.s_comment}}
                          </td>
                      </tr>
                    </template>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <template v-if="disp_jizen_list.length!=0 && Shakyo_data.jizen_jisshi == 1">
                    <tr >
                        <th colspan="2">
                            <label for="">事前説明会</label>
                        </th>
                    </tr>
                    <tr >
                        <td colspan="2">
                          <div align="left" v-for="(jizen_column,i) in disp_jizen_list" v-bind:key="i" class="jizen_disp">
                          
                            <!-- 種類が対面・オンライン・特殊の場合 -->
                            <table v-if="jizen_column.syurui != '3'" border="1" rules="all" style="width:100%;max-width:700px;border-collapse:collapse;margin-bottom:12px;border:2px solid #06F;background-color:cornsilk">
                            <tr>
                              <td width="150px"><b>説明会名称</b></td>
                              <td ><b>{{ jizen_column.jizen_name }}</b></td>
                            </tr>
                              <tr>
                              <td><b>種類</b></td>
                              <td ><b>{{ syurui_list[jizen_column.syurui] }}</b></td>
                            </tr>
                            <tr>
                              <td ><b>開催日</b></td>
                              <td >

                                    <template v-if="jizen_column.kensyu_date">
                                      {{ DateSetting(jizen_column.kensyu_date) }}
                                      
                                    </template>
                                    <template v-else>
                                      ー
                                    </template> 

                              </td>
                            </tr>
                            <tr>
                              <td ><b>説明会場所</b></td>
                              <td >{{ jizen_column.basyo }}</td>
                            </tr>
                            <template v-if="jizen_column.syurui == '1' || jizen_column.syurui == '3'">
                              <tr>
                                <td ><b>住所</b></td>
                                <td >
                                  <span v-if="jizen_column.jusyo == '' || jizen_column.jusyo == null  || jizen_column.jusyo == 'None'">ー</span>
                                  <u v-else style="color:red;cursor:pointer" v-on:click="jusho(jizen_column.jusyo)">{{ jizen_column.jusyo }}</u>
                                </td>
                              </tr>
                            </template>
                            <tr>
                              <td ><b>時間</b></td>
                              <td >
                                {{ TimeSetting(jizen_column.jizen_jikantai_start) }}&nbsp;～&nbsp;{{ TimeSetting(jizen_column.jizen_jikantai_end) }}
                              </td>
                            </tr>

                            <template v-if="jizen_column.bikou1 != '' && jizen_column.bikou1 != null && jizen_column.bikou1 != 'None'">
                                <tr>
                                  <td><b>特記事項</b></td>
                                  <td>
                                      <span style="color:red;">{{ jizen_column.bikou1 }}</span>
                                  </td>
                              </tr>
                            </template>
                            <tr style="border-top:2px solid #06F">
                              <td style="background-color:orange"><b>参加状況</b></td>
                              <td v-if="jizen_column.jokyo == 2" style="background-color:#ADE0EE;">
                                【参加済】<br class="sp_only">{{ EuDateTimeSetting(jizen_column.checkin_date) }} 
                              </td>
                              <td v-else style="background-color:#FFE4E1;" >
                                <span v-if="jizen_column.syurui == 2">
                                  <u  style="color:red;cursor:pointer" v-on:click="online_sanka(jizen_column.url)">オンライン説明会に参加する</u>
                                </span>
                                <span v-else>未参加</span>
                              </td>
                            </tr>
                            
                            <tr  v-if="jizen_column.syurui == 2">
                              <td style="background-color:orange"><b>ミーティングID</b></td>
                              <td >
                                {{jizen_column.meeting_id}}
                              </td>
                              
                            </tr>
                            <tr   v-if="jizen_column.syurui == 2">
                              <td style="background-color:orange"><b>パスコード</b></td>
                              <td >
                                {{jizen_column.passcode}}
                              </td>
                              
                            </tr>
                            </table>

                            <!-- 種類が動画視聴の場合 -->
                            <table v-else border="1" rules="all" style="width:100%;max-width:700px;border-collapse:collapse;margin-bottom:12px;border:2px solid #06F;background-color:cornsilk">
                            <tr>
                              <td width="100px"><b>説明会名称</b></td>
                              <td ><b>{{ jizen_column.jizen_name }}</b></td>
                            </tr>
                              <tr>
                              <td><b>種類</b></td>
                              <td ><b>動画視聴</b></td>
                            </tr>
                            
                            <tr>
                              <td ><b>視聴期間</b></td>
                              <td >

                                  <template v-if="jizen_column.movie_start_date && jizen_column.kensyu_date">
                                    <!--両方とも入力-->
                                    {{ DateSetting(jizen_column.movie_start_date) }} ～ {{ DateSetting(jizen_column.kensyu_date) }}
                                  </template>
                                  <template v-else-if="!jizen_column.movie_start_date && jizen_column.kensyu_date">
                                    <!--至のみ入力-->
                                    {{ DateSetting(jizen_column.kensyu_date) }} まで
                                  </template>
                                  <template v-else-if="jizen_column.movie_start_date && !jizen_column.kensyu_date">
                                    <!--自のみ入力-->
                                    {{ DateSetting(jizen_column.movie_start_date) }} 以降
                                  </template>
                                    <template v-else>
                                      ー
                                    </template> 

                              </td>
                            </tr>
                            <template v-if="jizen_column.bikou1 != '' && jizen_column.bikou1 != null && jizen_column.bikou1 != 'None'">
                                <tr>
                                  <td><b>特記事項</b></td>
                                  <td>
                                      <span style="color:red;">{{ jizen_column.bikou1 }}</span>
                                  </td>
                              </tr>
                            </template>
                            <tr style="border-top:2px solid #06F">
                              <td style="background-color:orange"><b>状況</b></td>
                              <td v-if="jizen_column.jokyo == 2" style="background-color:#ADE0EE;">
                                【視聴済】<br class="sp_only">{{ EuDateTimeSetting(jizen_column.checkin_date) }}  <br>
                                <template v-if="Shichou_kikan(jizen_column.kensyu_date,jizen_column.movie_start_date)">
                                  <u style="color:red;cursor:pointer" v-on:click="movie_shichou(jizen_column.url,jizen_column.jizen_id,2)">動画を視聴する</u>
                                </template>
                                  <template v-else>
                                    <b>動画の視聴期間外です。</b>
                                  </template>
                              </td>
                              <td v-else style="background-color:#FFE4E1;" >
                                  <template v-if="Shichou_kikan(jizen_column.kensyu_date,jizen_column.movie_start_date)">
                                    <u style="color:red;cursor:pointer" v-on:click="movie_shichou(jizen_column.url,jizen_column.jizen_id,1)">動画を視聴する</u>
                                  </template>
                                  <template v-else>
                                    <b>動画の視聴期間外です。</b>
                                  </template>
                              
                              </td>
                            </tr>
                            </table>
                            </div>
                        </td>
                    </tr>
                    </template>
                    <template v-if="disp_jigo_list.length!=0 && Shakyo_data.jigo_jisshi == 1">
                    <tr >
                        <th colspan="2">
                            <label for="">事後集会</label>
                        </th>
                    </tr>
                    <tr >
                        <td colspan="2">
                          <div align="left" v-for="(jigo_column,i) in disp_jigo_list" v-bind:key="i" class="jizen_disp">

                            <table border="1" rules="all" style="width:100%;max-width:700px;border-collapse:collapse;margin-bottom:12px;border:2px solid #06F;background-color:cornsilk">
                            <tr>
                              <td width="150px"><b>集会名称</b></td>
                              <td ><b>{{ jigo_column.jigo_name }}</b></td>
                            </tr>
                              <tr>
                              <td><b>種類</b></td>
                              <td ><b>{{ syurui_list[jigo_column.jigo_syurui] }}</b></td>
                            </tr>
                            <tr>
                              <td ><b>開催日</b></td>
                              <td >{{ DateSetting(jigo_column.jigo_kaisai) }}</td>
                            </tr>
                            <tr>
                              <td ><b>開催場所</b></td>
                              <td >{{ jigo_column.jigo_basyo }}</td>
                            </tr>
                            <template v-if="jigo_column.jigo_syurui == 1" >
                              <tr>
                                <td ><b>住所</b></td>
                                <td >
                                  <span v-if="jigo_column.jigo_jusyo == '' || jigo_column.jigo_jusyo == null  || jigo_column.jigo_jusyo == 'None'">ー</span>
                                  <u v-else style="color:red;cursor:pointer" v-on:click="jusho(jigo_column.jigo_jusyo)">{{ jigo_column.jigo_jusyo }}</u>
                                </td>
                              </tr>
                            </template>
                            <tr>
                              <td ><b>時間</b></td>
                              <td >
                                {{ TimeSetting(jigo_column.jigo_jikantai_start) }}&nbsp;～&nbsp;{{ TimeSetting(jigo_column.jigo_jikantai_end) }}
                              </td>
                            </tr>
                            <template  v-if="jigo_column.jigo_bikou1 != '' && jigo_column.jigo_bikou1 != null && jigo_column.jigo_bikou1 != 'None'">
                                <tr>
                                  <td><b>特記事項</b></td>
                                  <td>
                                      <span style="color:red;">{{ jigo_column.jigo_bikou1 }}</span>
                                  </td>
                              </tr>
                            </template>
                            <tr style="border-top:2px solid #06F">
                              <td style="background-color:orange"><b>参加状況</b></td>
                              <td v-if="jigo_column.jokyo == 2" style="background-color:#ADE0EE;">
                                【参加済】<br class="sp_only">{{ EuDateTimeSetting(jigo_column.checkin_date) }} 
                              </td>
                              <td v-else style="background-color:#FFE4E1;" >
                                <span v-if="jigo_column.jigo_syurui == 2">
                                  <u  style="color:red;cursor:pointer" v-on:click="online_sanka(jigo_column.jigo_url)">オンライン集会に参加する</u>
                                </span>
                                <span v-else>未参加</span>
                              </td>
                            </tr>
                            
                            <tr  v-if="jigo_column.jigo_syurui == 2">
                              <td style="background-color:orange"><b>ミーティングID</b></td>
                              <td >
                                <span v-if="jigo_column.jigo_meeting_id == '' || jigo_column.jigo_meeting_id == null  || jigo_column.jigo_meeting_id == 'None'">ー</span>
                                <span v-else>{{jigo_column.jigo_meeting_id}}</span>
                                
                              </td>
                              
                            </tr>
                            <tr   v-if="jigo_column.jigo_syurui == 2">
                              <td style="background-color:orange"><b>パスコード</b></td>
                              <td >
                                <span v-if="jigo_column.jigo_passcode == '' || jigo_column.jigo_passcode == null  || jigo_column.jigo_passcode == 'None'">ー</span>
                                <span v-else>{{jigo_column.jigo_passcode}}</span>
                              </td>
                              
                            </tr>
                            </table>

                            </div>
                        </td>
                    </tr>
                    </template>
                    <tr>
                        <td colspan="2">
                          <div class="vy-search-result-row-head " style="display:block;width: 100%;max-width:700px" >
                            <div class=" jyokyo_nittei" style="padding:5px;">制作・寄付品</div>
                                        
                          </div>

                          <div v-for="(result,i) in disp_jisseki" v-bind:key="i" class="vy-search-result-row">
                            <div class="vy-search-result-row-head " style="display:block;width: 100%;max-width:700px"  >
                              
                            
                            <div v-if="result.jokyo == 1" class=" jyokyo_nittei" style="padding:5px;background-color:#FFE4E1;">
                                    
                              未提出
                              </div>
                              <div v-else class=" jyokyo_nittei" style="padding:5px;background-color:#ADE0EE;">

                                【提出済】{{ EuDateTimeSetting(result.checkin_date) }} 
                              </div>
                             
                          </div>
                          </div>
                        </td>
                    </tr>
                   
                </table>

          <table class="vy-form-table" border="1" rules="all" style="margin-top:10px">


            <tr><td>
              <b class="sp_only">報告書・参加証明書の状況</b>
              <table class="jokyo_table " border="1" rules="all" >

                <tr>
                  <td width="25%">
                    <b>報告書</b>

                  </td>
                  <td v-if="houkoku==0 && (sanka!=1 || kesseki_f)" style="padding:3pt;background-color:#FFE4E1;cursor:default">
                    
                      <div v-if="Shakyo_data.houkoku_shubetsu ==2">ー</div>
                      <div v-else-if="taiken.google_form == 0">ー</div>
                      <div v-else>未提出</div>
                  </td>
                  <td v-if="houkoku==0 && sanka==1 && !kesseki_f" style="padding:3pt;background-color:ivory;">
                    
                    <div v-if="Shakyo_data.houkoku_shubetsu == 2 || taiken.google_form == 0">報告書の提出が必要です（提出方法は社協にお問い合わせください）。</div>
                    <div v-else v-on:click="quest()"><u style="color:#cc0000;cursor:pointer">活動報告書を提出してください。</u></div>
                  </td>
                  <td v-if="houkoku==1" style="padding:3pt;background-color:#ADE0EE;cursor:default">
                    【提出済】{{ EuDateTimeSetting(disp_jisseki[0].houkoku_date) }} 
                  </td>
                </tr>
              </table>
                
              <table class="jokyo_table " border="1" rules="all"  v-if="taiken.shomeisho != 0  && Shakyo_data.shomeisho_shubetsu == 1">
                <tr >
                  <td width="25%">
                    <b>参加証明書</b>

                  </td>
                  <!-- 日数を満たしていない -->
                  <td v-if="!nissu_ok" style="padding:3pt;background-color:#FFE4E1;cursor:default">参加証明書の発行には、全体で<u style="color:red">{{Shakyo_data.taiken_nissu}}日以上</u>の参加が必要です。</td>
                  
                  <!-- 参加完了 or 報告書の提出が終わっていない -->
                  <td v-else-if="syomei==0 && houkoku!=1" style="padding:3pt;background-color:#FFE4E1;cursor:default">未取得</td>
                  
                  <!-- 報告書の提出完了・事後集会へ未参加 -->
                  <td v-else-if="((syomei==0 || syomei==1) && houkoku==1) && jigo_ok() == false" style="padding:3pt;background-color:#FFE4E1;">
                    参加証明書の発行には、事後集会への参加が必要です。
                  </td>
                  
                  <!-- 報告書の提出完了・社協が未確認 -->
                  <td v-else-if="Shakyo_data.houkoku_kainyu == 1 && (disp_jisseki[0].houkoku_check == '' || disp_jisseki[0].houkoku_check == null || disp_jisseki[0].houkoku_check == 'None')" style="padding:3pt;background-color:#FFE4E1;">
                    社協が報告書を確認するまで、発行できません。
                  </td>

                  <!-- 状況が欠席(証明書発行可)の場合は、証明書は発行できません。 -->
                  <td v-else-if="kesseki_f" style="padding:3pt;background-color:#FFE4E1;">
                    【欠席】※参加証明書の発行はできません。
                  </td>


                  <!-- ダウンロード可能・一回もダウンロードしていない -->
                  <td v-else-if="syomei==0 && houkoku==1" style="padding:3pt;background-color:ivory;cursor:pointer">
                    
                    <div v-on:click="cert()"><u style="color:#cc0000">参加証明書を取得可能です。</u> 0 / {{shomaisho_count}}回</div>
                  </td>
                  <!--
                    <td v-if="syomei==1" style="padding:3pt;background-color:#ADE0EE;cursor:default"><div>
                    【発行済】{{ EuDateTimeSetting(disp_jisseki[0].syomei_date) }} 
                  </div></td>-->
                  
                  <!-- ダウンロード可能・一回以上ダウンロードしている -->
                  <td v-else-if="syomei == 1 && disp_jisseki[0].syomei_count != shomaisho_count" style="padding:3pt;background-color:ivory;">

                      <div><u style="color:#cc0000;cursor:pointer" v-on:click="cert()">参加証明書を取得可能です。</u></div>
                      【発行日】<br class="sp_only">{{ EuDateTimeSetting(disp_jisseki[0].syomei_date) }}<br>
                      【発行数】{{disp_jisseki[0].syomei_count}} / {{shomaisho_count}}回

                  </td>
                  
                  <!-- ダウンロード不可 -->
                  <td v-else-if="syomei==1 && disp_jisseki[0].syomei_count == shomaisho_count" style="padding:3pt;background-color:#ADE0EE;">
                    【発行日】<br class="sp_only">{{ EuDateTimeSetting(disp_jisseki[0].syomei_date) }}<br>
                    【発行数】{{disp_jisseki[0].syomei_count}} / {{shomaisho_count}}回
                  </td>
                </tr>
                </table>

            </td></tr>
          </table>
          
            <hr>
            <table class="vy-form-table" border="1" rules="all" style="margin-top:10px;max-width: 700px;">
              <tr>
                <td style="display: flex;align-items: center;justify-content: space-between;">
                  <b>連絡事項(社協へのメッセージ)</b><button class="btn mx-aut rireki_button"  v-on:click="Message_rireki_open()">送信履歴</button>
                </td>
              </tr>
              <tr>
                <td >
                  <table style="width:100%" border="1" rules="all" >
                    <tr>
                      <td >
                      <b>メッセージタイトル(連絡事項の項目)</b><br>
                        <input type="text" style="width:100%" v-model="message_title" />
                      </td>
                    </tr>
                    
                    <tr>
                      <td >
                      <b>内容<span style="color:red">（必須）</span></b><br>
                      <textarea style="width:100%" rows=3 v-model="message_honbun" ></textarea>

                      </td>
                    </tr>

                  </table>
                </td>
              </tr>

              <tr><td style="display: flex;justify-content: center;">
                <button class="btn mx-aut message_button"  v-on:click="Message_check()">送信する</button>
              </td></tr>
            </table>

      </div>
      <template v-if="cancel_ok == 0">
        <button class="btn mx-aut cancel_button" style="margin-top:10px" v-on:click="Cancel_check(i)">このプログラムをキャンセルする</button>
      </template>
    <br clear="all">
    </div>
        <!-- ボタン -->
         <div class="pc_only"  style="text-align:center;padding:6px;width: 100%;">
            <button class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;margin-right:10px" v-on:click="mypage()">戻る</button>
        </div>
      
  </div>
     <!-- スマホ専用ボタン（フローティングメニューの上に配置） -->
     <div class="vy-responsive-menu-container floating_over"  style="
          margin-bottom: 50px;
          padding: 10px 0;
          background: rgba(0, 0, 0, .5);
          border: 0px;
          justify-content: space-evenly;">
          <button class="btn btn-primary mx-aut" style="width: 45%; height: 50px;padding: 0;background-color: white;color:#4175d0;border:1px solid #000"  v-on:click="mypage()">戻る</button>
          
      </div>
      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>

                
      <!-- 送信済みメッセージ -->
      <div id="overlay" v-if="message_open">
        <div id="message_area" style="height:70%;width:95%;max-width: 800px;background-color: white;">
          <div style="margin: auto;
            width: 95%;
            height: 85%;
            margin-top: 3%;
            overflow-y: scroll;">
            <div v-if="message_rireki.length == 0" style="margin-top:10px">送信したメッセージはありません。</div>
              <template v-else  v-for="(message,i) in message_rireki" v-bind:key="i">
              <table align="left" style="width:100%;margin-bottom:10px">
                <tr>
                  <td width="25%">送信日時</td>
                  <td>
                      {{ EuDateTimeSetting(message.toroku_timestamp) }}
                  </td>
                </tr>
                <tr>
                  <td >タイトル</td>
                  <td>
                    <span v-if="message.message_title != '' && message.message_title != null">
                    {{ message.message_title }}
                    </span>
                    <span v-else>
                      （無題）
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colspan=2 style="text-align:left">
                    {{ message.message_honbun }}
                  </td>
                </tr>

              </table>
            </template>
          </div>
          <div style="height:10%">
            <button class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;background-color: blue;color:white;"  v-on:click="Message_rireki_close()">閉じる</button>
          </div>
        </div>
    
      </div>
</template>

<script setup>
/* eslint-disable */ 
import { useRouter,useRoute } from 'vue-router'
import { GlobalData, DateSetting,TimeSetting,EuDateTimeSetting,ShimekiriSetting  } from '../js/userdata.js'
import AWS from 'aws-sdk';
import axios from 'axios'
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import MessageModal from '../common/MessageModal.vue'  
import { format } from 'date-fns';
//const fileInput = ref(null);
const router = useRouter()
const route = useRoute()
const props = defineProps(['param'])
const taiken = props.param.shosai        // 体験プログラムのテーブル
const jisseki = props.param.jisseki        // 体験プログラムの実績テーブル
const sanka = ref(props.param.sanka)       // 体験プログラムに参加したかどうか
const houkoku = ref(props.param.houkoku)   // 体験プログラムの報告をしたかどうか
const syomei = ref(props.param.syomei)     // 体験プログラムの参加証明を取得したかどうか
const program_id = taiken.taiken_id  // 体験プログラムのID
const jizen_list = props.param.jizen_list // このユーザーが申込んだ事前説明会
const jigo_list = props.param.jigo_list // このユーザーが申込んだ事後集会
const moshikomi_count = props.param.moshikomi_count // このユーザーがこのプログラムを何回申し込んだか
const mail_list = props.param.mail_list // 自動送信メールのリスト


let sub_list = taiken.sub_list // この体験プログラムの他の活動条件


let moushikomi_date = new Date()


// 申込んだ事前説明会の中で、このプログラムに紐づく事前説明会
const disp_jizen_list = ref([])

// 申込んだ事後集会の中で、このプログラムに紐づく事後集会
const disp_jigo_list = ref([])

// この申し込みにおける全体の初日（施設・地域）、もしくは終了日（制作・寄付）
let start_date = new Date()
let start_count = 0

// 表示する実績
let disp_jisseki = []
let disp_count = 0


// 実績がキャンセル待ちの場合、何番目なのかをチェック
let jisseki_count_error = 0

// 全て欠席（証明書発行可）を判定するためのフラグ
let work_f = true


let family_flg = ref(false)  // 家族フラグ(家族の登録が出来る)が設定されている時は、右メニューのボタンが表示される

let family_flg_get_error = 0
const family_flg_get = () => {
    let res = null
    axios.post(GlobalData.$API_URL+"TaikenAccountUser_read", {taikenuser_id:GlobalData.user_id})
    .then(response => {
        
        if(response.data.accountuser){
            res = response.data.accountuser
            family_flg.value = res['family']

        } else {
            family_flg.value = false
        }
    })
    .catch(error => {
        if(family_flg_get_error == 6){
            alert(error + GlobalData.$axios_error)
        }else{
            family_flg_get_error++
            setTimeout(function(){family_flg_get()},"1000")
        }
        
    })
}

family_flg_get()

for(let j = 0; j<jisseki.length;j++){

  // メインプログラムIDと申込回数が合致する実績を確認
  if(jisseki[j].program_id == program_id && jisseki[j].jokyo != 9){
    if(jisseki[j].moshikomi_count == moshikomi_count){ 
      // 合致する実績を一度も確認していないなら条件なしで代入

      console.log(jisseki[j])
      if(start_count == 0){
        start_date = jisseki[j].kaisai_date
      }else
      // 一番早い日付を初日とする
      if(start_date > jisseki[j].kaisai_date){
        start_date = jisseki[j].kaisai_date
      }
      start_count++
    }

    // 実績がキャンセル待ちの場合
    if(jisseki[j].jokyo == '0'){
      let ninzu_count = 0
      let send_array = {
        program_kbn: 1,
        program_id: jisseki[j].program_id,
        kaisai_date: jisseki[j].kaisai_date
      }
      console.log(jisseki[j].kaisai_date)
      axios.post(
          GlobalData.$API_URL + "Jisseki_Userread",
          send_array,
          GlobalData.$ID_Token
          ).then(response => {
              if(response.data.status == 1){
                alert("エラーが発生しました。\n" + response.data.message)
                return ""
              }

            let result = response.data.taikenusers
            console.log(result)
            
            const seen = new Set();

            const jisseki_list = result.filter(item => {
              if (seen.has(item.jisseki_jisseki_id)) return false;
              seen.add(item.jisseki_jisseki_id);
              return true;
            });
            console.log(jisseki_list)
            

            for(let j2 = 0; j2 < jisseki_list.length; j2++){

                  console.log(jisseki_list[j2].taikenuser_id+":"+jisseki_list[j2].jisseki_jisseki_id +"/"+jisseki_list[j2].jokyo )
              if(jisseki_list[j2].jokyo == "0"){
                if(jisseki_list[j2].taikenuser_id == jisseki[j].taikenuser_id){
                  break
                }else{
                  ninzu_count++
                }
              }
            }

            jisseki[j].cancel_count =  "（"+parseInt(ninzu_count+1) + "番目）"

          }).catch(error => {
              console.log(error)
        })


    }
  }

  // プログラムIDと申込回数が合致する実績を確認
  if(jisseki[j].program_id == program_id && jisseki[j].jokyo != 9){ 
    if(jisseki[j].moshikomi_count == moshikomi_count){
      disp_jisseki[disp_count] = jisseki[j]
      disp_count++
      moushikomi_date = disp_jisseki[0].moshikomi_date
    }
  }

  // 全て「欠席（証明書発行可）」の場合は、報告書・証明書の発行はできない。
  if(jisseki[j].program_kbn == 1){
    if(jisseki[j].jokyo != '3' && jisseki[j].jokyo != '9'){
      work_f = false
    }
  }
}

let kesseki_f = ref(work_f)

let disp_sub_jisseki = []
for(let s = 0;s<sub_list.length;s++){
  disp_sub_jisseki[s] = [] 
    let disp_sub_count = 0
  for(let j = 0;j<jisseki.length;j++){
      if(jisseki[j].program_id == sub_list[s].taiken_id && jisseki[j].jokyo != 9){ 
    console.log(sub_list[s] )
    console.log(jisseki[j])
        if(jisseki[j].moshikomi_count == moshikomi_count){
          jisseki[j].katsudou = sub_list[s]
          disp_sub_jisseki[s][disp_sub_count] = jisseki[j]
          disp_sub_count++
          moushikomi_date = disp_sub_jisseki[s][0].moshikomi_date

          // 実績がキャンセル待ちの場合
          if(jisseki[j].jokyo == '0'){
            let ninzu_count = 0
            let send_array = {
              program_kbn: 1,
              program_id: jisseki[j].program_id,
              kaisai_date: jisseki[j].kaisai_date
            }

            axios.post(
                GlobalData.$API_URL + "Jisseki_Userread",
                send_array,
                GlobalData.$ID_Token
                ).then(response => {
                    if(response.data.status == 1){
                      alert("エラーが発生しました。\n" + response.data.message)
                      return ""
                    }

                  let result = response.data.taikenusers

                  // 重複カラムを削除する
                  const seen = new Set();

                  console.log(result)

                  const jisseki_list = result.filter(item => {
                    if (seen.has(item.jisseki_jisseki_id)) return false;
                    seen.add(item.jisseki_jisseki_id);
                    return true;
                  });
                  console.log(jisseki_list)

                  for(let j2 = 0; j2 < jisseki_list.length; j2++){
                        console.log(jisseki_list[j2].taikenuser_id+":"+jisseki_list[j2].jisseki_jisseki_id +"/"+jisseki_list[j2].jokyo )
                    if(jisseki_list[j2].jokyo == "0"){
                      if(jisseki_list[j2].taikenuser_id == jisseki[j].taikenuser_id){
                        break
                      }else{
                        ninzu_count++
                      }
                    }
                  }

                  jisseki[j].cancel_count = "（"+parseInt(ninzu_count+1) + "番目）"

                }).catch(error => {
                    console.log(error)
              })


          }
        }
      }
  }

  console.log(disp_sub_jisseki[s])
}



// ユーザーデータ（キャンセル回数を取得）
let user_data = []

// メッセージ送信
let message_title = ref("")
let message_honbun = ref("")

// 送信済みメッセージ
let message_rireki = ref({})

// 送信済みメッセージ表示エリアオープンフラグ
let message_open = ref(false)

// 証明書発行回数
let shomaisho_count = ref(3)

// キャンセル可能回数
let max_cancel_count = ref(0)
let cancel_day = 1 // 申込キャンセル可能日数
let cancel_setting = 0 // キャンセル待ち機能 0：利用する、1：しない

// キャンセルOKかどうかのフラグ。0ならキャンセル可能
let cancel_ok = ref(1)

// 社協のメールアドレス
let shakyo_mail = ""

// 表示フラグ
// 分類1（固定）
// 分類2
// プログラム名（固定）
// 活動内容
// 施設住所
// 申込条件
// 受入先からのコメント
// 添付資料
// その他（特記事項）
// 参加費 ---- ここから下は施設・地域のみ
// 検温等
// マスク着用
// 昼食
// 持ち物
// 制作・寄付活動条件 ---- ここから下は制作・寄付のみ
// 届け先
// 受付〆切日数 ---- 施設・地域のみ
// 検便 ---- 施設・地域のみ
// 開催地名
// 連絡先
// アクセス方法
// 服装
let shosai_disp = ref([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0])

// 表示設定、証明書発行回数、キャンセル可能回数、社協Emailを取得
let shakyo_read = function(){
  axios.post(GlobalData.$API_URL+"Shakyo_read", 
          {shakyo:route.params.shakyo}
      ).then(response => {
              shosai_disp.value = response["data"].program_shosai_disp.split(',')
              shomaisho_count.value = response["data"].shomeisho_count
              max_cancel_count.value = response["data"].cancel_count
              cancel_day = response["data"].cancel_day
              cancel_setting = response["data"].cancel_setting
              shakyo_mail = response["data"].shakyo_email
              // キャンセル可能かどうか確認しにいく
              Cancel_day_check()
      })
      .catch(error => {
          
  })
}


  // ユーザーデータを取得（主にキャンセル回数）
  let user_read_error = 0
  let user_read = function(){
    axios.post(GlobalData.$API_URL + "TaikenUser_read",
    {
          taikenuser_id: GlobalData.user_id
    },
      GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
      //正常な結果が返ってきた場合の処理
      // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが取得できなかった等）
      // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

      if(response.data["status"] == 1){

              message.value = GlobalData.$axios_error
              message_cat.value = 0;
              message_flag.value = true;
              message_method.value = "read_error";
              contentMessage.value = MessageModal
      }else{
        user_data = response.data;
      }
        shakyo_read()
              
    })
    .catch(error => { 
          if(user_read_error == 6){
              message.value = error + GlobalData.$axios_error;
              message_cat.value = 0;
              message_flag.value = true;
              message_method.value = "user_read_error";
              contentMessage.value = MessageModal
          }else{
              user_read_error++
              setTimeout(function(){
                user_read() 
              },"1000")
          }
      })
    }
  user_read()

// 社協が設けた体験義務日数を満たしているか
let nissu_ok = ref(false)

// このユーザーがチェックインした体験プログラムの数
const taiken_checkin_count = props.param.taiken_checkin_count

// 所属する社協のデータ
const Shakyo_data = props.param.Shakyo_data
// 参加日数（チェックイン済の数）と義務日数を比較
if(taiken_checkin_count >= Shakyo_data.taiken_nissu){
  nissu_ok.value = true
}else if(Shakyo_data.taiken_nissu == 1){
  nissu_ok.value = true
}

/* メッセージを表示するモーダルウィンドウ */

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

const emit = defineEmits(['call'])



// 表示モード
let mode = ref("dsp")

// 曜日配列
const youbi_list = ["日","月","火","水","木","金","土"]

// 事前説明会の種類配列
const syurui_list = ["（未設定）","対面","オンライン","動画視聴","特殊（対面）","特殊（オンライン）"]
const modoru = () => {
    mode.value = "dsp"
}


const quest = () => {
    message.value = "活動報告を行いますか？";
    message_cat.value = 1;
    message_flag.value = true;
    message_method.value = "go_quest";
    contentMessage.value = MessageModal 
}

const go_quest = () => {
  taiken.program_id = taiken.taiken_id
  /*
    let url = "https://docs.google.com/forms/d/e/1FAIpQLSeKqXbge7W5qHdIfQf7bXtfBSQtBYb2n6fkMLJcaizKFx_JfA/viewform?usp=pp_url&entry.1466441063="
              + GlobalData.user_id + ":" + program_id
    window.open(url)
    emit('call', { cmd:'quest', program_id:program_id })
    
    emit('call', { cmd:'quest', program:taiken })*/
    
    emit('call', { cmd:'report', program_id:taiken.program_id,form_no:taiken.google_form})
//    router.push("/"+route.params.shakyo+"/Taiken/report/"+taiken.google_form)
}

const cert = () => {
    message.value = "参加証明書をダウンロードしますか？";
    message_cat.value = 1;
    message_flag.value = true;
    message_method.value = "go_cert";
    contentMessage.value = MessageModal 
}

const go_cert = () => {
    let url = "/"+route.params.shakyo+"/Taiken/Shomei/" + GlobalData.user_id + "/" +program_id+"/"+moshikomi_count

    window.open(url)
    emit('call', { cmd:'cert', program_id:program_id ,syomei_count:disp_jisseki[0].syomei_count,moshikomi_count:moshikomi_count})
}

// 申込済み事前説明会から表示・キャンセルする事前説明会を抽出する
let Cancel_Jizen_check = function(){

  

  // 申込事前説明会が存在する場合のみ処理する
  if(jizen_list.length != 0){

    // 先に特殊説明会の存在チェック
    for(let j = 0;j<jizen_list.length;j++){
      // 実績が存在していたら格納
      if(jizen_list[j]["jokyo"] != 9){
        if(jizen_list[j]["syurui"] == 4 || jizen_list[j]["syurui"] == 5){
            disp_jizen_list.value[disp_jizen_list.value.length] = jizen_list[j]
        }
      }
    }


    // 特殊説明会がない、かつ、プログラムに事前説明会が設定されている場合
    if(taiken["jizenkensyu_no"] && disp_jizen_list.value.length == 0){

      let kensyu_array = Array.from(new Set(taiken["jizenkensyu_no"].split(",")))

      // 説明会No.を抽出
      for(let k = 0;k<kensyu_array.length;k++){
        // 事前説明会実績を確認
        for(let j = 0;j<jizen_list.length;j++){
          // 実績が存在していたら格納
          if(jizen_list[j]["jokyo"] != 9){
            if(kensyu_array[k] == jizen_list[j]["jizen_no"]){
                disp_jizen_list.value[disp_jizen_list.value.length] = jizen_list[j]
            }
          }
        }
      }
    }
  }
}

  // 申込済み事後集会から表示・キャンセルする事後集会を抽出する
let Cancel_Jigo_check = function(){

// 申込事後集会が存在する場合のみ処理する
if(jigo_list.length != 0){
    // プログラムに事後集会が設定されている場合
    if(taiken["jigosyukai_no"]){

        let syukai_array = Array.from(new Set(taiken["jigosyukai_no"].split(",")))

        // 集会No.を抽出
        for(let s = 0;s<syukai_array.length;s++){
          // 事後集会実績を確認
          for(let j = 0;j<jigo_list.length;j++){
            // 実績が存在していたら格納
            if(syukai_array[s] == jigo_list[j]["jigo_no"]){
              disp_jigo_list.value[disp_jigo_list.value.length] = jigo_list[j]
            }

          }
        }
    }
  }

}


// キャンセルが可能な場合は、参加日の初日が設定された日数より後かどうかチェック
// 後ならキャンセル可能
const Cancel_day_check = () =>{

  // ① キャンセル可能回数チェック
  if (max_cancel_count.value == 0) {
    console.log("キャンセルできません：回数0回");
    cancel_ok.value = 0;
    return;
  }

  if (user_data.cancel_count >= max_cancel_count.value) {
    console.log("キャンセルできません：キャンセル回数超過");
    cancel_ok.value = 0;
    return;
  }

  console.log(taiken.shubetsu)

  // プログラム種別が「施設・地域」の場合
  if(taiken.shubetsu == 1){
      // ② 今日（Asia/Tokyo）の0時を取得
      let today = new Date();
      today = new Date(today.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" }));
      today.setHours(0, 0, 0, 0);

      // ③ 初日（start_dateを日本時間として解釈）の0時
      let set_date = new Date(start_date);
      set_date = new Date(set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" }));
      set_date.setHours(0, 0, 0, 0);

      console.log("今日:", today.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" }));
      console.log("初日:", set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" }));

      // ④ 日数差を計算（初日 − 今日）
      let checkDay = (set_date - today) / 86400000;
      console.log("残り日数：" + checkDay + " / 許容：" + cancel_day);

      // ⑤ 判定：「初日の cancel_day 日までキャンセル可能」
      // → checkDay >= cancel_day ならキャンセル可能
      // → checkDay < cancel_day ならキャンセル不可
      if (checkDay >= cancel_day) {
        cancel_ok.value = 0;
        console.log("キャンセル可能");
      } else {
        cancel_ok.value = 1;
        console.log("キャンセル不可：締切を過ぎています");
      }
  }else{
    // プログラム種別が「制作・寄付」の場合
    // ② 実績の中にチェックイン済みの実績があればボタンを隠す
    cancel_ok.value = 0;
    for(let j = 0; j<jisseki.length;j++){

      // メインプログラムIDと申込回数が合致する実績を確認
      if(jisseki[j].program_id == program_id && jisseki[j].jokyo != 9){
        if(jisseki[j].moshikomi_count == moshikomi_count){ 
          console.log(jisseki[j].jokyo )
          if(jisseki[j].jokyo >= 2){
              cancel_ok.value = 1;
              console.log("キャンセル不可：参加済みか欠席");
          }
        }
      }
    }
  }
  
}

// 体験プログラムをキャンセルする
let cancel_error = 0
let Taiken_cancel = function(){

  // API側ではキャンセル対象のプログラムIDをカンマ区切りで送ることにより、全てのIDの実績をキャンセルできる
  // まずメインを格納
  let cancel_program_id = program_id
  // サブがある場合はそのIDも格納
  if(sub_list.length != 0){
    for(let s = 0;s<sub_list.length;s++){
      cancel_program_id += ","+sub_list[s].taiken_id
    }
  }

  let send_array = {
    user_id: GlobalData.user_id,
    program_id:cancel_program_id,
    program_kbn:1,
    jokyo:9,
    moshikomi_count:moshikomi_count,
    update_user:GlobalData.$User_email //更新者（＝ログインユーザーのメールアドレス）
  }
  axios.post(GlobalData.$API_URL + "Jisseki_Programupdate",send_array,GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
  .then(response => {
    if(response.data["status"] == 1){
        
    }else{
      // キャンセル待ち機能を利用するならキャンセル待ち実績をチェックする
      if(cancel_setting == 0){
        Jisseki_Wait_check()
      }else{
        message.value = "キャンセルしました。";
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "mypage_reload";
        contentMessage.value = MessageModal
      }

      rireki_add(2)
    }
  })
  .catch(error => {  
      if(cancel_error == 6){
          message.value = error + GlobalData.$axios_error;
          message_cat.value = 0;
          message_flag.value = true;
          message_method.value = "cancel_error";
          contentMessage.value = MessageModal
      }else{
          cancel_error++
          setTimeout(function(){
            Taiken_cancel() 
          },"1000")
      }
      
  })
}


// 他のユーザーにキャンセル待ちがいるかどうかチェック
let jisseki_wait_error = 0
let Jisseki_Wait_check = function(){
  let cancel_list = []

  // 体験プログラムの全実績データを取得してキャンセル配列として納める
  // 区分が1（体験プログラム）、かつ、IDが同じ、かつ、参加前
  for(let j = 0; j<jisseki.length;j++){
    if(jisseki[j].program_kbn == 1 && jisseki[j].main_taiken_id == program_id  && jisseki[j].jokyo == 1){
      cancel_list[cancel_list.length] = {"program_id":jisseki[j].program_id,"kaisai_date":jisseki[j].kaisai_date,"kaisai_date":jisseki[j].kaisai_date}
    }
  }

  // 自分がキャンセルしたものに「参加前」が1つも存在しなかったら終了
  if(cancel_list.length == 0){
    message.value = "キャンセルしました。";
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "mypage_reload";
    contentMessage.value = MessageModal
    return
  }

  let send_array = {"cancel_list":cancel_list}
  axios.post(GlobalData.$API_URL + "Jisseki_Waitread",send_array,GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
  .then(response => {
    if(response.data["status"] == 1){
        console.log(response.data["message"])

    }else if(response.data["status"] == 2){
        message.value = "キャンセルしました。";
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "mypage_reload";
        contentMessage.value = MessageModal
    }else{
      
        // 実績配列を取り出す
        let up_jisseki = response.data["jisseki"] 
        console.log(up_jisseki)

        console.log(mail_list[9].jisshi )
        // 実績配列からその人がそのプログラムに参加する実績を全て取得し（申込回数も考慮）、「全ての実績がキャンセル待ちじゃなかったら」メールを送る
        for(let j = 0;j<up_jisseki.length;j++){
          if(mail_list[9].jisshi == true){
            let send_jisseki = up_jisseki[j]
            // 対象者がいない場合もあるので、その場合はスルー
            if(send_jisseki.length != 0){
                let jisseki = send_jisseki[0] // 配列だが1件しかないので0番地を取得
                console.log(jisseki)
                // キャンセル待ちがあるかどうかチェック、ないならメール送信へ
                jisseki_user_read(jisseki)

            }
          }

          if(j+1 == up_jisseki.length){
            message.value = "キャンセルしました。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "mypage_reload";
            contentMessage.value = MessageModal
          }
        }
    }
  })
  .catch(error => {  
      if(jisseki_wait_error == 6){
          message.value = error + GlobalData.$axios_error;
          message_cat.value = 0;
          message_flag.value = true;
          message_method.value = "cancel_error";
          contentMessage.value = MessageModal
      }else{
          jisseki_wait_error++
          setTimeout(function(){
            Jisseki_Wait_check() 
          },"1000")
      }
      
  })
}


// その人の実績にキャンセル待ちがほかに存在するか確認
// キャンセル待ちがいなかったらメール送信
let jisseki_user_error = 0
let jisseki_user_read = function(jisseki){
  
    let send_array = {"program_kbn":1,"program_id":jisseki.program_id,"taikenuser_id":jisseki.taikenuser_id}
      
    axios.post(GlobalData.$API_URL + "Jisseki_Userread",
        send_array,
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            //正常な結果が返ってきた場合の処理
            // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが取得できなかった等）
            // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

            if(response.data["status"] == 1){
                alert("エラーが発生しました。\n"+response.data["message"])
            }else{

              let jisseki_list = response.data["taikenusers"]
              let send_flg = 1 // 0ならメール送信不可
              for(let j = 0;j<jisseki_list.length;j++){

                // キャンセル待ち実績だった場合
                if(jisseki_list[j].jokyo == "0"){
                  send_flg = 0
                }
              }

              console.log("send_flg:"+send_flg)

              // キャンセル待ちがなくなっていたらメール送信
              if(send_flg == 1){

                // メールの内容を作成
                let set_title = mail_list[9].title
                let set_text = ""

                if(mail_list[9].naiyou != "" && mail_list[9].naiyou != null){
                    set_text = mail_list[9].naiyou.replace(/<br>/g, '\n')
                }
                    
                // 各項目を変換

                // 体験プログラム・内容
                let set_naiyo = "名称："+jisseki.name+"\n"
                set_naiyo += "場所："+jisseki.k_jusyo+"\n"
                set_naiyo += "内容："+jisseki.naiyou+"\n"
                /*
                set_naiyo += "\n【参加日時】\n"
                set_naiyo += DateSetting(jisseki.kaisai_date)+" "
                set_naiyo += TimeSetting(jisseki.jikantai_start) +"～"+TimeSetting(jisseki.jikantai_end)*/

                set_text = set_text.replace(/<体験プログラム・内容>/g, set_naiyo)
                
                // 体験プログラム・日程
                let set_nittei = ""   
                for(let j2 = 0;j2<jisseki_list.length;j2++){
                   if(j2!=0) set_nittei += "\n"
                   set_nittei += "（"+(j2+1)+"）"+DateSetting(jisseki_list[j2].kaisai_date)+" "
                      +TimeSetting(jisseki_list[j2].jikantai_start) +"～"+TimeSetting(jisseki_list[j2].jikantai_end)
                }

                set_text = set_text.replace(/<体験プログラム・日程>/g, set_nittei)
                
                // 申込者名
                set_text = set_text.replace(/<申込者名>/g, jisseki.username)

                mail_send(set_title,set_text,mail_list[9].critical,jisseki.taikenuser_id,jisseki.email)
              }

            }
        })
        .catch(error => {  
            if(jisseki_user_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_method.value = "read_error";
                message_cat.value = 0;
                message_flag.value = true;
                contentMessage.value = MessageModal
            }else{
                jisseki_user_error++
                setTimeout(function(){jisseki_user_read(jisseki)},"1000")
            }
        })
}

// キャンセル待ち→参加前繰り上がりメールを送る
let mail_send_error = 0
let mail_send = function(set_title,set_text,critical,user_id,email){
  let send_data = {email:email,title:set_title,text:set_text,reply_to:shakyo_mail}

    // APIへ値を送信する
    axios.post(GlobalData.$API_URL+"Mail_send",
    send_data,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
      // 正常終了時には送信履歴を追加する
      mail_rireki_add(set_title,set_text,critical,user_id)
    })
    .catch(error => {
        if(mail_send_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_error";
            contentMessage.value = MessageModal
        }else{
            mail_send_error++
            setTimeout(function(){
                mail_send(set_title,set_text,critical,user_id,email)
            },"1000")
        }
    })
}

//---------------- メールの送信履歴を追加する
let mail_rireki_error = 0
let mail_rireki_add = function(set_title,set_text,critical,user_id){

    let send_data = {shakyo_name:route.params.shakyo,
        choson_code:Shakyo_data.choson_code,
        taikenuser_id:user_id,
        syurui:9,
        title:set_title,
        naiyou:set_text,
        critical:critical
    }

    // APIへ値を送信する
    axios.post(GlobalData.$API_URL+"Mail_rireki_add",
    send_data,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {
       
    })
    .catch(error => {
        if(mail_rireki_error == 6){
          
        }else{
            mail_rireki_error++
            setTimeout(function(){
               mail_rireki_add(set_title,set_text,critical,user_id)
            },"1000")
        }
    })
}

  // 履歴登録
  let rireki_add_error = 0
let rireki_add = function(kubun){
    const today = new Date()
    let set_date = new Date(today);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    //rireki_kanri_add(set_date,2,GlobalData.user_id,1,program_id,0)
    let send_data = {shakyo_name:route.params.shakyo,
        choson_code:Shakyo_data.choson_code,
        taikenuser_id:GlobalData.user_id,
        program_kbn:1,
        program_id:program_id,
        kubun:kubun,
        toroku_date:set_date,
        moshikomi_count:moshikomi_count,
        update_user:GlobalData.$User_email}

        // APIへ値を送信する
        axios.post(GlobalData.$API_URL+"Rireki_add",
        send_data,
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {

            if(response.data["status"] == 1){

                message.value = GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "rireki_add_error";
                contentMessage.value = MessageModal
            }

            shakyo_mail_send()
            
        })
        .catch(error => {
          if(rireki_add_error == 6){
              message.value = error + GlobalData.$axios_error;
              message_cat.value = 0;
              message_flag.value = true;
              message_method.value = "rireki_add_error";
              contentMessage.value = MessageModal
          }else{
              rireki_add_error++
              setTimeout(function(){
                rireki_add(kubun) 
              },"1000")
          }
  })
}


//---------------- 社協英名からデータを取得
let shakyo_mail_send_error = 0
let shakyo_mail_send = function(){
    axios.post(GlobalData.$API_URL+"Shakyo_read", 
        {shakyo:route.params.shakyo}
        ).then(response => {

        if(response.data["status"] == 0){
          if(response["data"].shakyo_email != undefined && response["data"].shakyo_email != null )
            shakyo_mailsend(response["data"].shakyo_email)
          else{
            alert("社協のメールが登録されていません。")
          }
        }else{
          alert("エラーが発生しました。\n"+response.data["message"])
        }        
    })
    .catch(error => {
          if(shakyo_mail_send_error == 6){
              message.value = error + GlobalData.$axios_error
              message_cat.value = 1;
              message_flag.value = true;
              message_method.value = "shakyo_mail_send_error";
              contentMessage.value = MessageModal
          }else{
              shakyo_mail_send_error++
              setTimeout(function(){shakyo_mail_send()},"1000")
          } 
        
    })
}

// MyPageの体験プログラムからのメッセージを社協のメールに送信する
let shakyo_mailsend_error = 0
let shakyo_mailsend = function(email){
  let title = ''
  let honbun = ''
  if(message_title.value == '' || message_title.value == null){
    title = 'ボラ活エール【体験】  申込者からメッセージが届いています。'
  } else {
    title = message_title.value
  }
  honbun = '送信日時：' + format(new Date(), 'yyyy年MM月dd日 HH:mm:ss') + '\n'
  honbun += 'メッセージ送信者：' + user_data.username + '\n' 
  honbun += '対象プログラム：' + taiken.name + '\n'
  honbun += '---------------------------------------------------------' + '\n'
  honbun += message_honbun.value

  let send_data = {email:email,title:title,text:honbun,reply_to:shakyo_mail}

    // APIへ値を送信する
    axios.post(GlobalData.$API_URL+"Mail_send",
    send_data,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
    .then(response => {

    })
    .catch(error => {
        if(shakyo_mailsend_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "check_error";
            contentMessage.value = MessageModal
        }else{
            shakyo_mailsend_error++
            setTimeout(function(){shakyo_mailsend(email)},"1000")
        }
    })
}

//------------------------ ボタンの処理
// 送信するメッセージをチェックする
const Message_check = () =>{

  let send_message = ""
  if(message_honbun.value == ""){
    send_message = "メッセージの内容は必ず入力してください。"
    message_method.value = "message_error";
    message_cat.value = 0;
  }else{
    send_message = "【タイトル】<br>"
    if(message_title.value != ""){
      send_message += message_title.value
    }else{
      send_message += "（無題）"
    }
    send_message += "<br><br>【内容】<br>"+message_honbun.value
    send_message += "<br><br>この内容でメッセージを送信しますか？"
    message_method.value = "message_send";
    message_cat.value = 1;
  }

  message.value = send_message;
  message_flag.value = true;
  contentMessage.value = MessageModal
}

// このプログラムに関するメッセージを取得する
let message_read_error = 0
const Message_read = () =>{

  axios.post(GlobalData.$API_URL +"Message_read",
        {
          choson_code:Shakyo_data.choson_code,
          taikenuser_id:GlobalData.user_id,
          program_id:program_id
        },
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            if(response.data["status"] == 1){  // 異常終了時の処理
              message.value = "メッセージの取得に失敗しました。";
              message_cat.value = 0;
              message_flag.value = true;
              message_method.value = "message_error";
              contentMessage.value = MessageModal
                
            }else{// 正常終了時の処理
              message_rireki.value = response.data["message_kanri"]
            }
        })
        .catch(error => {
          if(message_read_error == 6){
              message.value = error + GlobalData.$axios_error;
              message_cat.value = 0;
              message_flag.value = true;
              message_method.value = "message_error";
              contentMessage.value = MessageModal
          }else{
              message_read_error++
              setTimeout(function(){
                Message_read() 
              },"1000")
          }
      })
}

// このプログラムに関する送信済みメッセージを表示する
const Message_rireki_open = () =>{
  message_open.value = true
}

// このプログラムに関する送信済みメッセージのウィンドウを閉じる
const Message_rireki_close = () =>{
  message_open.value = false
}

// メッセージのデータを追加する
let message_add_error = 0
const message_add = () =>{
  axios.post(GlobalData.$API_URL +"Message_add",
        {
          shakyo_name:Shakyo_data.choson_code,
          choson_code:Shakyo_data.choson_code,
          taikenuser_id:GlobalData.user_id,
          program_id:program_id,
          message_title:message_title.value,
          message_honbun:message_honbun.value,

        },
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            if(response.data["status"] == 1){  // 異常終了時の処理
              message.value = "メッセージの送信に失敗しました。時間をおいてから再度お試しください。";
              message_cat.value = 0;
              message_flag.value = true;
              message_method.value = "message_error";
              contentMessage.value = MessageModal
                
            }else{// 正常終了時の処理

              // 履歴を追加
              rireki_add(8)
              
              message.value = "メッセージを送信しました。";
              message_cat.value = 0;
              message_flag.value = true;
              message_method.value = "message_reload";
              contentMessage.value = MessageModal
            }
        })
        .catch(error => {
          if(message_add_error == 6){
              message.value = error + GlobalData.$axios_error;
              message_cat.value = 0;
              message_flag.value = true;
              message_method.value = "message_error";
              contentMessage.value = MessageModal
          }else{
              message_add_error++
              setTimeout(function(){
                message_add() 
              },"1000")
          }
      })
}


// 体験プログラムのキャンセル確認
const Cancel_check = () =>{

  // ユーザーの累積キャンセル回数が社協のキャンセル可能回数未満なら取り消し可能
  if(max_cancel_count.value > user_data.cancel_count ){
    message.value = "このプログラムの申込みを取り消しますか？<br>※申込みのキャンセルは所定の回数を超えた時、それ以降の申込みが出来なくなります。ご注意ください。";
    message_cat.value = 1;
    message_flag.value = true;
    message_method.value = "cancel_kettei";
    contentMessage.value = MessageModal
  }else{
    message.value = "<span style='color:red'>社協が定めたキャンセル可能回数の上限に達しておりますので、これ以上キャンセルすることはできません。<br>どうしてもキャンセルしたい場合は、社協にお問い合わせください。</span>";
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "cancel_error";
    contentMessage.value = MessageModal

  }
}


const canceled = () => {
    mode.value = "can"
}
const reset = () => {
    if (seltbl) {
        //alert("seltbl.length:"+seltbl.length)
        for (let i=0;i<seltbl.length;i++) {
            document.getElementById(seltbl[i].jikantai).style.backgroundColor = ""
        }
    }
    mode.value = "dsp"
    clicksw = 0
    seltbl.length = 0
}

let cancnt = 0
const jikantai = ref("")
const kettei = () => {
    if (seltbl.length > 0) {
        mode.value = "kakunin"
        jikantai.value = seltbl[cancnt].jikantai
    } else {
        mode.value = "nosel"
    }
}


// 視聴期間の確認（動画視聴の場合のみ）
let Shichou_kikan = function(shicho_day,start_day){
  let today = new Date()
    if(shicho_day && start_day){
      // 期間（自・至）両方入力
      let shicho_date = Shichou_kikan_Setting(shicho_day)
      let start_date = Shichou_kikan_Setting(start_day)
      // 今日の日付が視聴期間内なら動画視聴可能
      if (shicho_date >= today && start_date <= today) {
        return true
      } else {
        return false
      }
    }else if(!shicho_day && start_day){

      // 期間（自）のみ入力
      let start_date = Shichou_kikan_Setting(start_day)
      // 今日の日付が視聴期間内なら動画視聴可能
      if (start_date <= today) {
        return true
      } else {
        return false
      }
    }else if(shicho_day && !start_day){
      // 期間（至）のみ入力
      let shicho_date = Shichou_kikan_Setting(shicho_day)
      // 今日の日付が視聴期間内なら動画視聴可能
      if (shicho_date >= today) {
        return true
      } else {
        return false
      }
    }else{
      // 視聴期間（自・至）が未入力なら動画視聴可能
      return true
    }
}

 //〆切日を整える
 let Shichou_kikan_Setting = function(changedate){
    let date = Date.parse(changedate);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
      set_date.setHours(23, 59, 59);//23時59分59秒に設定

    //return date;
    return set_date
 }


//------------------- Googlemap（外部リンク）へ
const jusho = (set_jusho) => { window.open("http://local.google.co.jp/maps?q="+set_jusho,"_blank") }

//------------------- リンク
const home = () => { emit('call', { cmd:'home'}) }

//------------------- 添付資料（外部リンク）へ
const shiryo_open = (url)  => { 
  window.open(url,"_blank", "") 
}

//------------------- ZOOM等のオンライン参加（外部リンク）へ
const online_sanka = (url)  => { window.open(url,"_blank") }

//------------------- 動画視聴（外部リンク）へ
let movie_error = 0
const movie_shichou = (url,jizen_id,jokyo)  => { 
  window.open(url,"_blank") 

  // 視聴済みの場合はここで終了
  if(jokyo == 2){
    return
  }
  
  let send_array = {
    user_id: GlobalData.user_id,
    program_id:jizen_id,
    program_kbn:2,
    jokyo:2,
    update_user:GlobalData.$User_email //更新者（＝ログインユーザーのメールアドレス）
  }
  axios.post(GlobalData.$API_URL+"Jisseki_CheckIn-Out", 
    send_array,
   GlobalData.$ID_Token)
    .then(response => {
     
      location.reload()
    })
    .catch(error => {
      if(movie_error == 6){
          message.value = error + GlobalData.$axios_error;
          message_cat.value = 0;
          message_flag.value = true;
          message_method.value = "movie_error";
          contentMessage.value = MessageModal
      }else{
          movie_error++
          setTimeout(function(){
            movie_shichou(url,jizen_id,jokyo)
          },"1000")
      }
    })
}


// 事後集会参加確認
const jigo_ok = () => {
  // プログラムの事後集会No.
  let jigo_no = taiken.jigosyukai_no

  // 事後集会No.を格納する配列
  let jigo_no_list = [];

  // 体験プログラムの割付事後集会No.を取り出す
  if(jigo_no != "" && jigo_no != null){
    jigo_no_list = jigo_no.split(',')

    // 事後集会に参加しているかどうか
    let ok_flg = 0;
    for(let i = 0;i < jigo_list.length;i++){
      // プログラムに紐づいたNo.があればその参加状況をチェック
      for(let t = 0;t<jigo_no_list.length;t++){
        if(jigo_no_list[t] == jigo_list[i]["jigo_no"]){

          // 参加が任意なら状況に関わらずOK
          if(jigo_list[i]["syomei_flg"] == 1){
            ok_flg = 1
          }else{
            // 未参加・キャンセルではない場合はOK
            if(jigo_list[i]["jokyo"] != 1 && jigo_list[i]["jokyo"] != 9) ok_flg = 1
          }
        }
      }
    }

    if(ok_flg == 1){
      return true
    }else{
      return false
    }
  }else{
    // ない場合はtrue
    return true
  }
}

const mypage = () => {
    emit('call', { cmd:'mypage',id:''})
}

defineExpose({
  canceled,
});


// メッセージを表示するウィンドウでOKを押された時
let ok_message_error = 0
let OK_message = function(){ 
    Close_message();//メッセージを表示するウィンドウを閉じる

    // プログラムをキャンセルする
    if(message_method.value == "cancel_kettei"){
      Taiken_cancel()
    }else if(message_method.value =="mypage_reload"){
      // キャンセル後の処理
      // APIへ値を送信する
      axios.post(GlobalData.$API_URL +"TaikenUser_update",
        {
          taikenuser_id: GlobalData.user_id,
          cancel_count:user_data.cancel_count + 1

        },
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            // マイページをリロード
            router.go("/User/mypage")
        })
        .catch(error => {
          if(ok_message_error == 6){
              message.value = error + GlobalData.$axios_error;
              message_cat.value = 0;
              message_flag.value = true;
              message_method.value = "movie_error";
              contentMessage.value = MessageModal
          }else{
              ok_message_error++
              setTimeout(function(){
                OK_message()
              },"1000")
          }
      })
    }else if(message_method.value == "message_send"){
      // メッセージを送信しますか？
      message_add()
      
    }else if(message_method.value =="message_reload"){
      // メッセージ部分をリロード
      message_title.value = ""
      message_honbun.value = ""

      // 送信済みメッセージを再読み込み
      Message_read()
    }else if(message_method.value == "go_quest"){
      //活動報告を行いますか？
      go_quest()
    }else if(message_method.value == "go_cert"){
      // 参加証明書を発行しますか？
      go_cert()
    }

}

// メッセージを表示するウィンドウを閉じる
let Close_message = function(){
    message_flag.value = false;
    contentMessage.value = null
}

// ユーザー切替え画面の表示
const multipleusers_change = () =>{
    emit('call', { cmd:'multipleprofile_switch',id:GlobalData.user_id})
}

let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/HOME-165c0be34f8f806ea21ed5c10d5a46e4"
    window.open(url,"_blank")
}

// Q&Aを開く
const qanda_open = () =>{

  let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
  window.open(url,"_blank")
}        

// ？マークをタップしたときのウィンドウ（スマホのみ）
let q_open = function(text){
    message.value = text
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "q_open";
    contentMessage.value = MessageModal

}

  /* 初期処理 */
  Cancel_Jizen_check()
  Cancel_Jigo_check()
  Message_read()
  
  emit('call', { cmd:'page_scroll' })
</script>

<style scoped>
    #tab {
        width: 100%;
        margin: auto;
    }
    #tab_detail{
        border-radius: 5px 0 0 0;
    }
    #tab_calendar{
        border-radius: 0 5px 0 0;
    }
    #tab_list {
        border-left: 2px solid #FFF;
        border-right: 2px solid #FFF;
    }
  .tabblue{
      color: #fff;
      background-color: #06F;
  }
  .tabgray{
      color: #fff;
      background-color:#d3d3d3 ;
  }
  .tabMenu {
    display: flex;
    padding: 0;
    margin-bottom:0;
   }

  .tabMenu li {
      list-style:none;
      width: 33%;
      padding: 10px 20px;
      cursor: pointer;
  }
  .tabContents {
    border:1px solid rgb(170,170,170);
    padding: 15px;
  }

  .list_column_left{
    border-left:1px solid #000;
    border-right:1px solid #000;
    width:30%;
  } 
  .list_column_standard{
    border-right:1px solid #000;
    border-top:1px solid #000;
    width:30%;
  }
  .list_column_center{
    border-right:1px solid #000;
    border-top:1px solid #000;
    width:40%;
  }
  .list_column_header{
    border-top:1px solid #000;
    border-bottom:1px solid #000;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #title_area,#list_column_area,:deep(#calendar_column_area){
    display: flex;
    align-items: center;
  }
  #list_column_area div{
    height:40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  #calendar_button_area{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  }
  .month_change{
    cursor: pointer;
    border-bottom: 1px solid #000;
  }
  
  :deep(.calendar_column){
    width:14%;
    border-right: 1px solid #000;
    border-bottom:1px solid #000;
  }
  :deep(.calendar_column_right){
    width:15%;
    border-right: 1px solid #000;
    border-bottom:1px solid #000;
  }
  :deep(.calendar_column_left){
    width:15%;
    border-right: 1px solid #000;
    border-left: 1px solid #000;
    border-bottom:1px solid #000;
  }
  
  
  :deep(.column_date_blank){
    height: 100px;
  }
  :deep(.column_date){
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
  }
  :deep(.column_date_day){
    height:30px;
    display: flex;
    align-items: center;
  }
  :deep(.column_date_time){
    height:25px;
    width:100%;
    font-size: 13px;
    line-height: 15px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  :deep(.column_date_time_left){
    width: 55%;
    text-align: left;
    padding: 0;
    display: flex;
    justify-content: center;
  }
.jyokyo_nittei{
  border: 1px solid #000;
    display: flex;
    align-items: center;
}

.cancel_button{
  float:right;
  height: 40px;
  padding: 10px;
  background-color: red;
  color: white;
  margin-right: 5px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}
.message_button{
    height: 40px;
    width:95%;
    max-width: 200px;
    text-align: center;
    padding: 10px;
    background-color: red;
    color: white;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
.cancel_button:hover,
.message_button:hover{
  background-color: red;
  color: white;
}

.rireki_button{
    height: 30px;
    width:100px;
    text-align: center;
    padding: 10px;
    background-color: green;
    color: white;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  
}
.rireki_button:hover{
  background-color: green;
  color: white;

}
.jokyo_table {
  width:100%;
}

.jokyo_table tr td{
  border:1px solid #000
}

.jizen_disp table tr td{
  padding: 5px;
  border: 1px solid #ccc;
}
  .jizen_disp table tr td:nth-of-type(1){
    min-width:120px;
    width: 120px;
  }
/* レスポンシブ対応 */
@media screen and (max-width: 960px) {
  /*スマホ*/
  .jokyo_table {
    margin-top: 10px;
  }
.floating_over{
        display: flex
    }

    .jizen_disp table tr td{
      width:auto;
      display:table-cell;
    }
    
}
@media screen and (min-width: 961px) {
  /*PC*/
  .jokyo_table {
    max-width: 700px;
  }
  .floating_over{
    display: none
  }
}
#overlay{
  /* 要素を重ねた時の順番 */
  z-index:1;

  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);

  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
